window.RFC_REVIEWS_DATA = [
  {
    "id": "6ac7cdc3682672e16af93011",
    "author": "M**l",
    "rating": 5,
    "date": "2026-10-08",
    "content": "Absolutely love it. Extremely comfortable:)",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/a7bf09a296084642975dd16a7521c798.jpg?w=3024&h=4032"
    ],
    "productTitle": "90s Halloween Nostalgia T-shirt",
    "productHandle": "90s-halloween-nostalgia-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/3546a1b96a3dff94f7a7ee47cd63cac7.jpg?v=1791468957",
    "productUrl": "/products/90s-halloween-nostalgia-t-shirt"
  },
  {
    "id": "6ac66135682672e16af92da0",
    "author": "J**h",
    "rating": 5,
    "date": "2026-10-07",
    "content": "Love it. Quality fabric,Not thin.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/183d0ab994514b01af853ca96de74bb2.jpg?w=1080&h=2340"
    ],
    "productTitle": "90s Halloween Nostalgia T-shirt",
    "productHandle": "90s-halloween-nostalgia-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/3546a1b96a3dff94f7a7ee47cd63cac7.jpg?v=1791468957",
    "productUrl": "/products/90s-halloween-nostalgia-t-shirt"
  },
  {
    "id": "6ac56ea2682672e16af92c39",
    "author": "E**z",
    "rating": 5,
    "date": "2026-10-06",
    "content": "Absolutely love this practical magic T-shirt. The T-shirt itself is soft and I love the distressed black color. It does run a little big, but oversize is in. Highly recommend this T-shirt to any fan.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/3b72187936c1479c9fcd66aacc8bd712.jpg?w=4032&h=3024"
    ],
    "productTitle": "Savior of Our City T-shirt",
    "productHandle": "savior-of-our-city-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/2c3621f6d81fc1cc2edce4884ada2566.jpg?v=1791468963",
    "productUrl": "/products/savior-of-our-city-t-shirt"
  },
  {
    "id": "6ac51e7de1e4cfae462bf898",
    "author": "G**p",
    "rating": 5,
    "date": "2026-10-06",
    "content": "The shirt came exactly as advertised! The material is amazing as is the quality! I have gotten so many compliments. Will definitely purchase from here again.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/9fa172d7af17453ea6f686219b88d734.jpg?w=2736&h=3648"
    ],
    "productTitle": "Savior of Our City T-shirt",
    "productHandle": "savior-of-our-city-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/2c3621f6d81fc1cc2edce4884ada2566.jpg?v=1791468963",
    "productUrl": "/products/savior-of-our-city-t-shirt"
  },
  {
    "id": "6ac3eee7682672e16af929d0",
    "author": "J**e",
    "rating": 5,
    "date": "2026-10-05",
    "content": "Really happy with my purchase",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/4ba96902431243678c6ec541212b1242.jpeg?w=3024&h=4032",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/f326c4e543624e05aa86521c80247762.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Funny Wizard Sleigh Christmas Sweatshirt",
    "productHandle": "funny-wizard-sleigh-christmas-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/6a87128df9a6042a26152e3128168a6f.jpg?v=1791468969",
    "productUrl": "/products/funny-wizard-sleigh-christmas-sweatshirt"
  },
  {
    "id": "6ac215b8e1e4cfae462bf359",
    "author": "D**b",
    "rating": 5,
    "date": "2026-10-04",
    "content": "A fantastic t-shirt. I love the design & the quality. I haven't seen another like it. I love it.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/69cc7ed46a4a40d19df2f66d83f8109b.jpg?w=2252&h=3116"
    ],
    "productTitle": "Funny Wizard Sleigh Christmas Sweatshirt",
    "productHandle": "funny-wizard-sleigh-christmas-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/6a87128df9a6042a26152e3128168a6f.jpg?v=1791468969",
    "productUrl": "/products/funny-wizard-sleigh-christmas-sweatshirt"
  },
  {
    "id": "6abfb55de1e4cfae462befb7",
    "author": "D**M",
    "rating": 5,
    "date": "2026-10-02",
    "content": "Todo bien y a tiempo. Haciendo otro pedido. Gracias.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/90c8d80481f1478793d730396195ebb0.jpg?w=1024&h=1365"
    ],
    "productTitle": "Christmas Jingle Song Sweatshirt",
    "productHandle": "christmas-jingle-song-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/60752f88701a6d932ca5ebe90b79af08.jpg?v=1791468975",
    "productUrl": "/products/christmas-jingle-song-sweatshirt"
  },
  {
    "id": "6abeaf75e1e4cfae462bee41",
    "author": "L**m",
    "rating": 5,
    "date": "2026-10-01",
    "content": "I love this t-shirt,good quality and arrived well packaged. Now my friend wants one too!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/6b774664245b433da57a0151e114327b.jpg?w=1499&h=2223"
    ],
    "productTitle": "Christmas Jingle Song Sweatshirt",
    "productHandle": "christmas-jingle-song-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/60752f88701a6d932ca5ebe90b79af08.jpg?v=1791468975",
    "productUrl": "/products/christmas-jingle-song-sweatshirt"
  },
  {
    "id": "6abea95be1e4cfae462bee33",
    "author": "A**i",
    "rating": 5,
    "date": "2026-10-01",
    "content": "Everyone loved this shirt! Love when people identify with each mom!!!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/8f5c6850e84f44d982f303fcc8ca90b3.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Retro Tonight We Ride Christmas Christian Quote T-shirt",
    "productHandle": "retro-tonight-we-ride-christmas-christian-quote-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/cf18f6160ea9a60bd578c64c8b462988.jpg?v=1791468982",
    "productUrl": "/products/retro-tonight-we-ride-christmas-christian-quote-t-shirt"
  },
  {
    "id": "6abe6161e1e4cfae462beda8",
    "author": "A**n",
    "rating": 5,
    "date": "2026-10-01",
    "content": "So funny I love it!  The quality is perfect and has held up perfectly in the washer and dryer.  Has not shrunk.  I get a ton of compliments when I wear it.  This was a huge hit when I wore it to pick up my dog’s prescription diet from the veterinary hospital I’m a nurse at.  10/10",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/8b35c735a4f34705abbe53ab9b8de00e.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Retro Tonight We Ride Christmas Christian Quote T-shirt",
    "productHandle": "retro-tonight-we-ride-christmas-christian-quote-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/cf18f6160ea9a60bd578c64c8b462988.jpg?v=1791468982",
    "productUrl": "/products/retro-tonight-we-ride-christmas-christian-quote-t-shirt"
  },
  {
    "id": "6abd7b5be1e4cfae462bec67",
    "author": "A**y",
    "rating": 5,
    "date": "2026-09-30",
    "content": "Love it! Got Medium, fits perfectly- not baggy not tight. 5’4” 130lbs",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/22e011b828ed49e6af765a3676fb94da.jpg?w=2316&h=3088"
    ],
    "productTitle": "Vintage Santa Sleigh Christmas Sweatshirt",
    "productHandle": "vintage-santa-sleigh-christmas-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/3d305897685d8ff6553bb5884a4de2e6.jpg?v=1791468987",
    "productUrl": "/products/vintage-santa-sleigh-christmas-sweatshirt"
  },
  {
    "id": "6abc3fc9682672e16af91e12",
    "author": "C**n",
    "rating": 5,
    "date": "2026-09-29",
    "content": "Shirt was even better than expected! Great quality and soft, relaxed fit. I had so many compliments on it when I wore it on “Dolly Day!”",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/273017810fa04eaea82123c56e3d105b.jpeg?w=2193&h=3086"
    ],
    "productTitle": "Vintage Santa Sleigh Christmas Sweatshirt",
    "productHandle": "vintage-santa-sleigh-christmas-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/3d305897685d8ff6553bb5884a4de2e6.jpg?v=1791468987",
    "productUrl": "/products/vintage-santa-sleigh-christmas-sweatshirt"
  },
  {
    "id": "6abc0306e1e4cfae462bea35",
    "author": "S**a",
    "rating": 5,
    "date": "2026-09-29",
    "content": "I absolutely love this Sweatshirt! It is soft and comfortable to wear. Even better, my friends read it and say it's just like you ;)",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/390edc45143e42e0b741ac948836b6ab.jpg?w=3072&h=4080"
    ],
    "productTitle": "Christmas Nostalgia T-shirt",
    "productHandle": "christmas-nostalgia-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/3d8826a5269fa6c80e94401a86277a48.jpg?v=1791468993",
    "productUrl": "/products/christmas-nostalgia-t-shirt"
  },
  {
    "id": "6abbc5dee1e4cfae462be9c0",
    "author": "l**n",
    "rating": 5,
    "date": "2026-09-29",
    "content": "So cute and the customer service was top notch!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/1a7279f690084e0295300dcd0b6fc156.jpg?w=2296&h=3056"
    ],
    "productTitle": "Christmas Nostalgia T-shirt",
    "productHandle": "christmas-nostalgia-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/3d8826a5269fa6c80e94401a86277a48.jpg?v=1791468993",
    "productUrl": "/products/christmas-nostalgia-t-shirt"
  },
  {
    "id": "6abbb263e1e4cfae462be99c",
    "author": "M**o",
    "rating": 4,
    "date": "2026-09-29",
    "content": "Very nice tshirt and quality, only issue is size large is a bit too short for what you would expect.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/3cef958a615f460dad7a7e674df930b7.jpg?w=2091&h=2473"
    ],
    "productTitle": "It's Just One Dam Project After Another T-shirt",
    "productHandle": "it-x27-s-just-one-dam-project-after-another-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/ac4d8d9b2269fbf4ef172b3a52abf65b.jpg?v=1791468999",
    "productUrl": "/products/it-x27-s-just-one-dam-project-after-another-t-shirt"
  },
  {
    "id": "6aba3e3c682672e16af91af7",
    "author": "D**z",
    "rating": 5,
    "date": "2026-09-28",
    "content": "I received this shirt about 2 weeks ago.  I love it.  I love the material and the size, Xtra large, fit me perfectly...Very happy with it!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/621f54d9c8f942f098f601beeaf77aaf.jpeg?w=810&h=1080"
    ],
    "productTitle": "It's Just One Dam Project After Another T-shirt",
    "productHandle": "it-x27-s-just-one-dam-project-after-another-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/ac4d8d9b2269fbf4ef172b3a52abf65b.jpg?v=1791468999",
    "productUrl": "/products/it-x27-s-just-one-dam-project-after-another-t-shirt"
  },
  {
    "id": "6ab999d9682672e16af91a07",
    "author": "H**s",
    "rating": 5,
    "date": "2026-09-27",
    "content": "Love it!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/c09c149af5824e7f9181cc84ad694d4d.jpeg?w=1242&h=2208"
    ],
    "productTitle": "You poopin Bigfoot Sasquatch T-shirt",
    "productHandle": "you-poopin-bigfoot-sasquatch-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/63be0935e9cbebac23811ec1d6357d29.jpg?v=1791469005",
    "productUrl": "/products/you-poopin-bigfoot-sasquatch-t-shirt"
  },
  {
    "id": "6ab8c6d5682672e16af918bd",
    "author": "K**r",
    "rating": 5,
    "date": "2026-09-27",
    "content": "Looks just as advertised. Very comfy good material doesn’t feel cheap. I’m 5’1” 120lb and I like an oversized fit, so I ordered medium and it fit just like intended. I usually wear a small.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/7e004969c2254afca64f9c0c063dbc6b.png?w=941&h=1672"
    ],
    "productTitle": "You poopin Bigfoot Sasquatch T-shirt",
    "productHandle": "you-poopin-bigfoot-sasquatch-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/63be0935e9cbebac23811ec1d6357d29.jpg?v=1791469005",
    "productUrl": "/products/you-poopin-bigfoot-sasquatch-t-shirt"
  },
  {
    "id": "6ab7ce21e1e4cfae462be40b",
    "author": "L**r",
    "rating": 5,
    "date": "2026-09-26",
    "content": "5 🌟’s!  A terrific quality t-shirt and graphics.  Also bought “a little witchy.”  Same great quality!!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/022112c02311467bb4d19eb921b1510e.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Girls Will Be Girls T-shirt",
    "productHandle": "girls-will-be-girls-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/7b1b30d819ae2618dd598b46bb94fbd0.jpg?v=1791469011",
    "productUrl": "/products/girls-will-be-girls-t-shirt"
  },
  {
    "id": "6ab6a64de1e4cfae462be2aa",
    "author": "A**n",
    "rating": 5,
    "date": "2026-09-25",
    "content": "I get so many compliments on this shirt! It fits true to size (I'm a size 16, ordered a large). Love it.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/6f66d2b2363142c9b35891e9b4e8fd9b.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Girls Will Be Girls T-shirt",
    "productHandle": "girls-will-be-girls-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/7b1b30d819ae2618dd598b46bb94fbd0.jpg?v=1791469011",
    "productUrl": "/products/girls-will-be-girls-t-shirt"
  },
  {
    "id": "6ab694c1e1e4cfae462be290",
    "author": "J**y",
    "rating": 5,
    "date": "2026-09-25",
    "content": "Soft, Comfort Colors, true to size. So many compliments on it. Wearing a size small. It’s 19.5 inches from armpit to armpit.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/e7467aebc44a4390a58485a62e25daa8.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Retro Japanese Inspired Dot Art T-shirt",
    "productHandle": "retro-japanese-inspired-dot-art-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/9cbf0a21e5a283e0a050a01b8d07306f.jpg?v=1791469017",
    "productUrl": "/products/retro-japanese-inspired-dot-art-t-shirt"
  },
  {
    "id": "6ab5f22ce1e4cfae462be1d3",
    "author": "M**r",
    "rating": 5,
    "date": "2026-09-25",
    "content": "Love this shirt as much as I expected! Great quality as well.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/845f80ee599b498e9247b8d4b3e9f3de.jpeg?w=1737&h=3088"
    ],
    "productTitle": "Retro Japanese Inspired Dot Art T-shirt",
    "productHandle": "retro-japanese-inspired-dot-art-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/9cbf0a21e5a283e0a050a01b8d07306f.jpg?v=1791469017",
    "productUrl": "/products/retro-japanese-inspired-dot-art-t-shirt"
  },
  {
    "id": "6ab58b50e1e4cfae462be145",
    "author": "Y**n",
    "rating": 5,
    "date": "2026-09-24",
    "content": "I’m a neonatal Kitten Rescuer, so I wear cat shirts all the time. I feel like this guy most days when feedings and pooping are going well! Love the glasses & Gaga jewelry he’s wearing. Today it’s a HighBack Charlie cover!!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/34ae990ef6d34605a9b9c60b4dd6810a.jpg?w=3024&h=4032"
    ],
    "productTitle": "Protect Your Daughters No Educate Your Sons T-shirt",
    "productHandle": "protect-your-daughters-no-educate-your-sons-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/103545aede4feb68ed615974ae51e300.jpg?v=1791469023",
    "productUrl": "/products/protect-your-daughters-no-educate-your-sons-t-shirt"
  },
  {
    "id": "6ab51f52e1e4cfae462be09b",
    "author": "W**n",
    "rating": 5,
    "date": "2026-09-24",
    "content": "High quality, thick cotton shirt. The fit is a bit boxy, so one of our friends cut it into a crop, but it looks great as is over spandex shorts or tucked into jeans. Everyone loved the design!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/5b8b7a7237a8483a945daf61344b0348.jpg?w=1848&h=1518"
    ],
    "productTitle": "Protect Your Daughters No Educate Your Sons T-shirt",
    "productHandle": "protect-your-daughters-no-educate-your-sons-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/103545aede4feb68ed615974ae51e300.jpg?v=1791469023",
    "productUrl": "/products/protect-your-daughters-no-educate-your-sons-t-shirt"
  },
  {
    "id": "6ab4fb06e1e4cfae462be05b",
    "author": "K**i",
    "rating": 5,
    "date": "2026-09-24",
    "content": "I love it!  It is oversized. I got a size smaller, and it is fine. The material is of a good quality cotton. And, it makes people laugh when I wear it.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/ec855595d4524b1a8a2823e6850d956e.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Autumn Floral Graphic T-shirt",
    "productHandle": "autumn-floral-graphic-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/e1247b0fa69dae463ec97e70f7ad9053.jpg?v=1791469029",
    "productUrl": "/products/autumn-floral-graphic-t-shirt"
  },
  {
    "id": "6ab3e34e682672e16af9126b",
    "author": "N**l",
    "rating": 5,
    "date": "2026-09-23",
    "content": "I love this shirt, just like I love birds!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/c31a541e3f5c47fa847bc4851f71c68e.jpg?w=4032&h=3024"
    ],
    "productTitle": "Autumn Floral Graphic T-shirt",
    "productHandle": "autumn-floral-graphic-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/e1247b0fa69dae463ec97e70f7ad9053.jpg?v=1791469029",
    "productUrl": "/products/autumn-floral-graphic-t-shirt"
  },
  {
    "id": "6ab3a9ea682672e16af91208",
    "author": "N**a",
    "rating": 5,
    "date": "2026-09-23",
    "content": "I had to have this shirt! The message is on point, soft fabric great fit!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/d84f2f74efe04df9b9743a372c0be645.jpeg?w=3023&h=4030"
    ],
    "productTitle": "Vintage Country Wiener Dog Lover T-shirt",
    "productHandle": "vintage-country-wiener-dog-lover-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/72bad78025e22d9612dde696475e7e42.jpg?v=1791469035",
    "productUrl": "/products/vintage-country-wiener-dog-lover-t-shirt"
  },
  {
    "id": "6ab37799e1e4cfae462bde30",
    "author": "L**r",
    "rating": 5,
    "date": "2026-09-23",
    "content": "My favorite Fall shirt. Sturdy fabric, well-stitched and unique. I love this t- shirt.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/31ff6f9fa90d43a386da28ed31073ba9.jpg?w=3000&h=4000"
    ],
    "productTitle": "Vintage Country Wiener Dog Lover T-shirt",
    "productHandle": "vintage-country-wiener-dog-lover-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/72bad78025e22d9612dde696475e7e42.jpg?v=1791469035",
    "productUrl": "/products/vintage-country-wiener-dog-lover-t-shirt"
  },
  {
    "id": "6ab33575e1e4cfae462bddd8",
    "author": "A**o",
    "rating": 5,
    "date": "2026-09-23",
    "content": "Love it! Comfortable soft and perfect!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/0346340863a04329b08e3504530b4c7f.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Sparkly Christmas Graphic Sweatshirt",
    "productHandle": "sparkly-christmas-graphic-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/7d040143dfd5b3d6dc941332cffff010.jpg?v=1791469040",
    "productUrl": "/products/sparkly-christmas-graphic-sweatshirt"
  },
  {
    "id": "6ab2cee9e1e4cfae462bdd54",
    "author": "c**s",
    "rating": 5,
    "date": "2026-09-22",
    "content": "This will be my daughter's new favorite shirt!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/74c3ecbd68ec4a45b67f96fb93a1bf62.jpg?w=3000&h=4000"
    ],
    "productTitle": "Sparkly Christmas Graphic Sweatshirt",
    "productHandle": "sparkly-christmas-graphic-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/7d040143dfd5b3d6dc941332cffff010.jpg?v=1791469040",
    "productUrl": "/products/sparkly-christmas-graphic-sweatshirt"
  },
  {
    "id": "6ab27b0a682672e16af9105f",
    "author": "A**)",
    "rating": 5,
    "date": "2026-09-22",
    "content": "Great quality, unisex sizing, runs a little large",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/09cca9e9337e438ba105eb73a3d97d6f.jpeg?w=3672&h=4896"
    ],
    "productTitle": "Embroidered Merry Gingham Mockneck Sweatshirt",
    "productHandle": "embroidered-merry-gingham-mockneck-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/3262a84b20a7040b94d0efa77c686750.jpg?v=1791469046",
    "productUrl": "/products/embroidered-merry-gingham-mockneck-sweatshirt"
  },
  {
    "id": "6aafd1b7c5eaeb589a6ec5c9",
    "author": "J**r",
    "rating": 5,
    "date": "2026-09-20",
    "content": "Honestly, I was so surprised when I opened this package up - in the best way. I thought I was getting Instagram scammed and thought at best the shirt would arrive and the print would be a little crooked on a super low quality shirt. This shirt’s weight is amazing and looks and feels like a higher end product! It’s heavier than a regular Hanes t shirt but quite a bit, but it doesn’t feel stiff - it has a nice drape to it. The print looks cute and I get compliments whenever I wear it. Such a fun surprise when you buy something unserious expecting a lemon and get something so much better than you imagined.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/225f36270fb24453bf1b82e7a3791bee.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Embroidered Merry Gingham Mockneck Sweatshirt",
    "productHandle": "embroidered-merry-gingham-mockneck-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/3262a84b20a7040b94d0efa77c686750.jpg?v=1791469046",
    "productUrl": "/products/embroidered-merry-gingham-mockneck-sweatshirt"
  },
  {
    "id": "6ab2cee9e1e4cfae462bdd54",
    "author": "c**s",
    "rating": 5,
    "date": "2026-09-22",
    "content": "This will be my daughter's new favorite shirt!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/74c3ecbd68ec4a45b67f96fb93a1bf62.jpg?w=3000&h=4000"
    ],
    "productTitle": "Fun Aunt Knight Riding Black Cat T-shirt",
    "productHandle": "fun-aunt-knight-riding-black-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260729151611-3271-1.png?v=1791469916",
    "productUrl": "/products/fun-aunt-knight-riding-black-cat-t-shirt"
  },
  {
    "id": "6a8c4812c413ecbfbfa5935d",
    "author": "M**n",
    "rating": 5,
    "date": "2026-08-24",
    "content": "My daughter loves hers!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/cb9b36105b14488982108054e8cdf353.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Fun Aunt Knight Riding Black Cat T-shirt",
    "productHandle": "fun-aunt-knight-riding-black-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260729151611-3271-1.png?v=1791469916",
    "productUrl": "/products/fun-aunt-knight-riding-black-cat-t-shirt"
  },
  {
    "id": "6aade917229247de45561c9b",
    "author": "J**s",
    "rating": 5,
    "date": "2026-09-19",
    "content": "Am I a cool dad? My kids think so thanks to this shirt. Is that the Coors Logo font? My church dads chat thinks so. But of course it isn’t because we don’t want any cease and desist letters do we? This shirt is an absolute baller. Incredible design and HOLY COW the material and print quality are top tier. Super comfy and makes me look way sexier to my Cryptid obsessed wife than I have a right to be. 11/10 would buy again.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/5da04f277c9247c88f903be247fe73a3.jpeg?w=4896&h=3672"
    ],
    "productTitle": "He's From Texas I Can Tell T-shirt",
    "productHandle": "he-x27-s-from-texas-i-can-tell-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/9a28598b3faae033ce858e15b1389fab.jpg?v=1791469945",
    "productUrl": "/products/he-x27-s-from-texas-i-can-tell-t-shirt"
  },
  {
    "id": "6aad0b15229247de45561b47",
    "author": "B**d",
    "rating": 5,
    "date": "2026-09-18",
    "content": "Absolutely adorable t-shirt that is perfect for the Halloween season! The first day that I wore it out, I received a compliment on it. It did take longer than I expected for it to come in, but it was worth the wait.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/1c1b199e47a5455aac6ec4e082d422a1.jpg?w=3000&h=4000",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/7598672f8fd8462f8e2a490b1426ec63.jpg?w=3000&h=4000"
    ],
    "productTitle": "He's From Texas I Can Tell T-shirt",
    "productHandle": "he-x27-s-from-texas-i-can-tell-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/9a28598b3faae033ce858e15b1389fab.jpg?v=1791469945",
    "productUrl": "/products/he-x27-s-from-texas-i-can-tell-t-shirt"
  },
  {
    "id": "6aacf99d229247de45561b28",
    "author": "J**n",
    "rating": 5,
    "date": "2026-09-18",
    "content": "Love my T-shirt! So comfy and a really great, thick material",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/0e027b42f08a45eaa4bb947b602a1aaf.jpg?w=2736&h=3648"
    ],
    "productTitle": "Halloween Wiener Dog T-shirt",
    "productHandle": "halloween-wiener-dog-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/halloween-_5.jpg?v=1791469987",
    "productUrl": "/products/halloween-wiener-dog-t-shirt"
  },
  {
    "id": "6aacce1c229247de45561ae3",
    "author": "J**e",
    "rating": 5,
    "date": "2026-09-18",
    "content": "Love it. I’m wearing the small. My stepson wants one now, too.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/2baaec5c02784e709f7525676e7246a8.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Halloween Wiener Dog T-shirt",
    "productHandle": "halloween-wiener-dog-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/halloween-_5.jpg?v=1791469987",
    "productUrl": "/products/halloween-wiener-dog-t-shirt"
  },
  {
    "id": "6aac977f229247de45561aa2",
    "author": "D**o",
    "rating": 5,
    "date": "2026-09-18",
    "content": "Love love love this shirt! So comfortable and such a cool design. I've already gotten compliments.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/57e1071380944a07b152d28798d5d427.jpg?w=2522&h=1920"
    ],
    "productTitle": "Vintage Grumpy Crow T-shirt",
    "productHandle": "vintage-grumpy-crow-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/66da316ab824b4271590cde30c5ef54a.jpg?v=1791470053",
    "productUrl": "/products/vintage-grumpy-crow-t-shirt"
  },
  {
    "id": "6aa9faabc5eaeb589a6ebbba",
    "author": "M**l",
    "rating": 5,
    "date": "2026-09-16",
    "content": "Love this shirt. Everyone comments on it. Fit and quality are great.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/dce44f4cd3d34aa996888d2ba8c5ca61.jpeg?w=2284&h=3088"
    ],
    "productTitle": "Vintage Grumpy Crow T-shirt",
    "productHandle": "vintage-grumpy-crow-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/66da316ab824b4271590cde30c5ef54a.jpg?v=1791470053",
    "productUrl": "/products/vintage-grumpy-crow-t-shirt"
  },
  {
    "id": "6aa95824c5eaeb589a6ebad5",
    "author": "K**y",
    "rating": 5,
    "date": "2026-09-15",
    "content": "I love it! Exactly what I wanted, thick quality material and soft!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/aab3f2a9a682472e94fc41d73ea68838.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Vintage Horror Movie T-shirt",
    "productHandle": "vintage-horror-movie-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260820161122-1296-14.jpg?v=1791470096",
    "productUrl": "/products/vintage-horror-movie-t-shirt"
  },
  {
    "id": "6aa902e0c5eaeb589a6eba3b",
    "author": "L**n",
    "rating": 5,
    "date": "2026-09-15",
    "content": "Perfect t-shirt and my love of corvids makes it even better. The quality is excellent and feels so comfy. Will definately be buying another one.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/c7e1d5dee7464083a031f86c7395b353.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Vintage Horror Movie T-shirt",
    "productHandle": "vintage-horror-movie-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260820161122-1296-14.jpg?v=1791470096",
    "productUrl": "/products/vintage-horror-movie-t-shirt"
  },
  {
    "id": "6aa8ad1dc5eaeb589a6eb9c6",
    "author": "K**r",
    "rating": 5,
    "date": "2026-09-15",
    "content": "You would not even believe, or maybe you can, just how recognizable this shirt was/is at the 2026 Indy True Oktoberfest. Such a rewarding moment when several different, random fest goers pointed and exclaimed, “OMG! I love your shirt!! JIMOTHY!!!”. A piece of 2026 Threads Lore and Meme history preserved. 🫶🦝",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/fb633e0b6e644b6f977e25a56b56dc5d.jpeg?w=4032&h=2268",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/3661d3cfd55141dda6961af077a2f75f.jpeg?w=1737&h=3088"
    ],
    "productTitle": "Shocked Funny Doll Graphic T-shirt",
    "productHandle": "shocked-funny-doll-graphic-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/bff77957276a1928ab22c785600db0d6.jpg?v=1791470116",
    "productUrl": "/products/shocked-funny-doll-graphic-t-shirt"
  },
  {
    "id": "6aa8ac2dc5eaeb589a6eb9c3",
    "author": "K**r",
    "rating": 5,
    "date": "2026-09-15",
    "content": "Fits great! Feels like a heavy duty fabric and the faux rugged black/grey is Aesthetic I dig. JIMOTHY!!! Such a great message too. #ally",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/b594a296793841eaa388e8d4f8ce79c8.jpeg?w=1737&h=3088"
    ],
    "productTitle": "Shocked Funny Doll Graphic T-shirt",
    "productHandle": "shocked-funny-doll-graphic-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/bff77957276a1928ab22c785600db0d6.jpg?v=1791470116",
    "productUrl": "/products/shocked-funny-doll-graphic-t-shirt"
  },
  {
    "id": "6aa81e54229247de45561200",
    "author": "P** ",
    "rating": 5,
    "date": "2026-09-14",
    "content": "Excellent service and quick response to enquiry, very pleased with my purchase 5stars",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/455b37705c6d400cb2c8ca19e885cba6.jpeg?w=1123&h=1130"
    ],
    "productTitle": "Jimothy Raccoon T-shirt",
    "productHandle": "jimothy-raccoon-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260729151611-3270-1.png?v=1791470142",
    "productUrl": "/products/jimothy-raccoon-t-shirt"
  },
  {
    "id": "6aa6ace78b011d27db23a25b",
    "author": "E**k",
    "rating": 5,
    "date": "2026-09-13",
    "content": "Love it ! I’m a size S-M but I bought a L(I love oversize) and it looks so cute, I love the material !",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/3a67f18b9e4f4e70a0ef125d64af075a.jpeg?w=2388&h=2944"
    ],
    "productTitle": "Jimothy Raccoon T-shirt",
    "productHandle": "jimothy-raccoon-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260729151611-3270-1.png?v=1791470142",
    "productUrl": "/products/jimothy-raccoon-t-shirt"
  },
  {
    "id": "6aa485488b011d27db239fb5",
    "author": "T**y",
    "rating": 5,
    "date": "2026-09-11",
    "content": "Absolutely LOVE these tees!! I get compliments and chuckles every time I wear a Rusty Fox Co. tee!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/faa0a52290c1467e8820a288e05fbaba.jpg?w=1848&h=1946"
    ],
    "productTitle": "National Geographic Otter Go with the Flow T-Shirt/Sweatshirt",
    "productHandle": "national-geographic-otter-go-with-the-flow-t-shirt-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/10-1277.jpg?v=1791470175",
    "productUrl": "/products/national-geographic-otter-go-with-the-flow-t-shirt-sweatshirt"
  },
  {
    "id": "6aa458d98b011d27db239f7e",
    "author": "E** ",
    "rating": 5,
    "date": "2026-09-11",
    "content": "Love our shirts!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/927173d0c1384a79ba9b6c54e8063919.jpeg?w=2316&h=3088"
    ],
    "productTitle": "National Geographic Otter Go with the Flow T-Shirt/Sweatshirt",
    "productHandle": "national-geographic-otter-go-with-the-flow-t-shirt-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/10-1277.jpg?v=1791470175",
    "productUrl": "/products/national-geographic-otter-go-with-the-flow-t-shirt-sweatshirt"
  },
  {
    "id": "6aa3b11c8b011d27db239e89",
    "author": "R**R",
    "rating": 5,
    "date": "2026-09-11",
    "content": "Very bright and attractive image, good long shirt, good quality.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/81534e64ebcc43c5977e47d783d01688.jpeg?w=2259&h=2817"
    ],
    "productTitle": "Vintage Tabby Cat Resist T-shirt",
    "productHandle": "vintage-tabby-cat-resist-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/6420af910a1fe849592e24963e7d20cb.jpg?v=1791470212",
    "productUrl": "/products/vintage-tabby-cat-resist-t-shirt"
  },
  {
    "id": "6aa2a1da6b77867da04d8e46",
    "author": "C** ",
    "rating": 5,
    "date": "2026-09-10",
    "content": "We gifted the “Hi Hungry, I’m Dad” shirts to my partner for Father’s Day. The first thing he said was, what an awesome shirt! Great fit, great quality. Shipping time was 10 business days to Australia. Would definitely order again!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/258e4f34808b4980bc4defec9b346175.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Vintage Tabby Cat Resist T-shirt",
    "productHandle": "vintage-tabby-cat-resist-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/6420af910a1fe849592e24963e7d20cb.jpg?v=1791470212",
    "productUrl": "/products/vintage-tabby-cat-resist-t-shirt"
  },
  {
    "id": "6aa20efe8b011d27db239c50",
    "author": "S**E",
    "rating": 5,
    "date": "2026-09-10",
    "content": "LOVE this shirt, especially because it’s sewn on the shirt. The shirt is also nice quality.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/0eefcdeeefd6401da09a61f438a97781.jpeg?w=1206&h=1052"
    ],
    "productTitle": "Retro Halloween T-shirt/Sweatshirt",
    "productHandle": "retro-halloween-t-shirt-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/halloween-_6.jpg?v=1791470244",
    "productUrl": "/products/retro-halloween-t-shirt-sweatshirt"
  },
  {
    "id": "6aa1181d8b011d27db239a66",
    "author": "R**i",
    "rating": 5,
    "date": "2026-09-09",
    "content": "Looks fantastic! Also the quality of t-shirt is spot-on.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/f4d776929ab64b6c8e770b4f0622352a.jpeg?w=2268&h=4032"
    ],
    "productTitle": "Retro Halloween T-shirt/Sweatshirt",
    "productHandle": "retro-halloween-t-shirt-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/halloween-_6.jpg?v=1791470244",
    "productUrl": "/products/retro-halloween-t-shirt-sweatshirt"
  },
  {
    "id": "6a981e228b011d27db238d49",
    "author": "B**n",
    "rating": 5,
    "date": "2026-09-02",
    "content": "Got this for the boyfriend and he loves it!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/ee649a3caef448bc8420db9d0ae8de5d.jpg?w=3024&h=4032"
    ],
    "productTitle": "Frog Howling to the Moon T-shirt",
    "productHandle": "frog-howling-to-the-moon-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/lQDPKGKCr8WQE0-NA3jNA3iwIuGbS43GePMJ8i-AqBAbAw-888-888.jpg?v=1791470296",
    "productUrl": "/products/frog-howling-to-the-moon-t-shirt"
  },
  {
    "id": "6a62dabb0b445406e80c893c",
    "author": "B**h",
    "rating": 5,
    "date": "2026-07-24",
    "content": "This is the best frog shirt I could ask for. The shirt is good and sturdy. The print came out well... And there's a howling frog. Like.... Do you NEED anything else?? It's amazing.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/1dd974b932664575aee5325ffb92c170.jpg?w=3072&h=4080"
    ],
    "productTitle": "Frog Howling to the Moon T-shirt",
    "productHandle": "frog-howling-to-the-moon-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/lQDPKGKCr8WQE0-NA3jNA3iwIuGbS43GePMJ8i-AqBAbAw-888-888.jpg?v=1791470296",
    "productUrl": "/products/frog-howling-to-the-moon-t-shirt"
  },
  {
    "id": "6a9ace208b011d27db239190",
    "author": "M**n",
    "rating": 5,
    "date": "2026-09-04",
    "content": "It brings me joyce, and joyce around me 😊",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/c123f18573d7429aa22f5ea76903a09e.jpg?w=1080&h=1428"
    ],
    "productTitle": "Le Boop Dragon Medieval T-Shirt",
    "productHandle": "le-boop-dragon-medieval-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/1-2384.jpg?v=1791470319",
    "productUrl": "/products/le-boop-dragon-medieval-t-shirt"
  },
  {
    "id": "6aa112a28b011d27db239a58",
    "author": "M**h",
    "rating": 5,
    "date": "2026-09-09",
    "content": "Super happy with my order! Good quality material, well made, and great prints! 5⭐",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/43113d134330420fb881717a5e03bbb7.jpg?w=3111&h=2227"
    ],
    "productTitle": "Le Boop Dragon Medieval T-Shirt",
    "productHandle": "le-boop-dragon-medieval-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/1-2384.jpg?v=1791470319",
    "productUrl": "/products/le-boop-dragon-medieval-t-shirt"
  },
  {
    "id": "6aa10f326b77867da04d8b9b",
    "author": "M**h",
    "rating": 5,
    "date": "2026-09-09",
    "content": "Very happy with my order. I got these two and have been wearing them both a lot since.  Exactly as pictured on website and sizes accurate. The material is thick and good quality and the print also good quality! 5 ⭐ !",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/8296829f62814aab8856f8c9c26156ea.jpg?w=3111&h=2227"
    ],
    "productTitle": "Meowdy Partner Cowboy Cat T-Shirt",
    "productHandle": "meowdy-partner-cowboy-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20240710162144.jpg?v=1791470853",
    "productUrl": "/products/meowdy-partner-cowboy-cat-t-shirt"
  },
  {
    "id": "6aa091846b77867da04d8ad7",
    "author": "P**i",
    "rating": 4,
    "date": "2026-09-08",
    "content": "Pretty Happy with this one, especially love the acidwash colour style. Will be interesting to see how the graphic lasts over washing but so far its going ok. I wish there was a few larger sizes as this is the largest size available - while it fits I love a baggy tee even as a plus size person.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/17a7b309772f4458bb307441cf6719d8.png?w=2316&h=3088"
    ],
    "productTitle": "Meowdy Partner Cowboy Cat T-Shirt",
    "productHandle": "meowdy-partner-cowboy-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20240710162144.jpg?v=1791470853",
    "productUrl": "/products/meowdy-partner-cowboy-cat-t-shirt"
  },
  {
    "id": "6a9f9aba8b011d27db23982b",
    "author": "W**L",
    "rating": 5,
    "date": "2026-09-08",
    "content": "❤️",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/abf0f001e76d4c4883970d7c9fdeb511.jpg?w=2252&h=4000"
    ],
    "productTitle": "Vintage Cowboy Racoon T-shirt",
    "productHandle": "vintage-cowboy-racoon-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20240715151640.jpg?v=1791470862",
    "productUrl": "/products/vintage-cowboy-racoon-t-shirt"
  },
  {
    "id": "6a9ee3c16b77867da04d8878",
    "author": "M**a",
    "rating": 5,
    "date": "2026-09-07",
    "content": "Obsessed. Probably the 3rd shirt I’ve bought from this company and they’re always great. All hail jimothy.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/c430bfd5dd954e2ea5bc141e109e1ef3.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Vintage Cowboy Racoon T-shirt",
    "productHandle": "vintage-cowboy-racoon-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20240715151640.jpg?v=1791470862",
    "productUrl": "/products/vintage-cowboy-racoon-t-shirt"
  },
  {
    "id": "6a9e72378b011d27db2396b3",
    "author": "R**R",
    "rating": 5,
    "date": "2026-09-07",
    "content": "Took a long time to get here but delighted with it. Good print image. Very colourful.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/8dfd69ad50d24c098626722ba663aa88.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Smoky Mountains National Park T-shirt",
    "productHandle": "smoky-mountains-national-park-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/12-10.jpg?v=1791470868",
    "productUrl": "/products/smoky-mountains-national-park-t-shirt"
  },
  {
    "id": "6a9d1d848b011d27db2394a9",
    "author": "S**l",
    "rating": 5,
    "date": "2026-09-06",
    "content": "Loved the shirt for the Australian Father’s Day. It’s great how it’s just a good vibe shirt, not even remotely political.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/330dd92ad83a4e40a7cc49f1b1d60c67.png?w=1086&h=1448"
    ],
    "productTitle": "Smoky Mountains National Park T-shirt",
    "productHandle": "smoky-mountains-national-park-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/12-10.jpg?v=1791470868",
    "productUrl": "/products/smoky-mountains-national-park-t-shirt"
  },
  {
    "id": "6a9cbe1a8b011d27db239434",
    "author": "C**m",
    "rating": 5,
    "date": "2026-09-06",
    "content": "Got this for my girlfriend. She was very happy",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/d71b35a4f607479cac3af6b529f4a3d0.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Vintage Yellowstone National Park T-shirt",
    "productHandle": "vintage-yellowstone-national-park-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/01123.jpg?v=1791470874",
    "productUrl": "/products/vintage-yellowstone-national-park-t-shirt"
  },
  {
    "id": "6a9c71ff6b77867da04d84c6",
    "author": "A**H",
    "rating": 5,
    "date": "2026-09-05",
    "content": "The best of my « summer T shirts » !!!!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/96d8ace9765b454f9617e213e59a7d73.jpeg?w=4032&h=3024"
    ],
    "productTitle": "Vintage Yellowstone National Park T-shirt",
    "productHandle": "vintage-yellowstone-national-park-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/01123.jpg?v=1791470874",
    "productUrl": "/products/vintage-yellowstone-national-park-t-shirt"
  },
  {
    "id": "6a9c0e456b77867da04d8453",
    "author": "I**r",
    "rating": 5,
    "date": "2026-09-05",
    "content": "Really cool t-shirt. I got a few complements for it too!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/86115900bcf14856af0e5091c521901d.jpeg?w=1041&h=944"
    ],
    "productTitle": "Cute Strawberry Dreams T-shirt",
    "productHandle": "cute-strawberry-dreams-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/859c0fe4021d79112da2a9f24b81fe6-0.jpg?v=1791470880",
    "productUrl": "/products/cute-strawberry-dreams-t-shirt"
  },
  {
    "id": "6a9b18ec6b77867da04d8318",
    "author": "E**s",
    "rating": 5,
    "date": "2026-09-04",
    "content": "This is a delightful design and the colors are vibrant. The base t-shirt isn’t solid black but rather an interesting mottled black/charcoal, which adds to the visual appeal.\n\nSo far it has help up in the wash as well!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/d51616a300bb44ad8beee030a120cab1.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Cute Strawberry Dreams T-shirt",
    "productHandle": "cute-strawberry-dreams-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/859c0fe4021d79112da2a9f24b81fe6-0.jpg?v=1791470880",
    "productUrl": "/products/cute-strawberry-dreams-t-shirt"
  },
  {
    "id": "6abd7b5be1e4cfae462bec67",
    "author": "A**y",
    "rating": 5,
    "date": "2026-09-30",
    "content": "Love it! Got Medium, fits perfectly- not baggy not tight. 5’4” 130lbs",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/22e011b828ed49e6af765a3676fb94da.jpg?w=2316&h=3088"
    ],
    "productTitle": "Space Cowgirl T-Shirt",
    "productHandle": "space-cowgirl-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20240725154932_1.jpg?v=1791470886",
    "productUrl": "/products/space-cowgirl-t-shirt"
  },
  {
    "id": "69884346ca84e3db64bbb5c2",
    "author": "E**s",
    "rating": 5,
    "date": "2026-02-08",
    "content": "The fabric and print quality are good. Only thing for me is that the t-shirts are WAY too long. We can work with that though 😉",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/4210efea3bb74379b2c8c047e4fa3918.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Space Cowgirl T-Shirt",
    "productHandle": "space-cowgirl-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20240725154932_1.jpg?v=1791470886",
    "productUrl": "/products/space-cowgirl-t-shirt"
  },
  {
    "id": "6a9ace208b011d27db239190",
    "author": "M**n",
    "rating": 5,
    "date": "2026-09-04",
    "content": "It brings me joyce, and joyce around me 😊",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/c123f18573d7429aa22f5ea76903a09e.jpg?w=1080&h=1428"
    ],
    "productTitle": "Poppies Sweatshirt",
    "productHandle": "poppies-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/18a97ee2f14c492783bee1c032b7b3b3.jpg?v=1791470892",
    "productUrl": "/products/poppies-sweatshirt"
  },
  {
    "id": "6a9aaae56b77867da04d8252",
    "author": "B**s",
    "rating": 5,
    "date": "2026-09-04",
    "content": "So happy with this shirt! The saying is so awesome for being a first time Mom!  I feel so comfortable with the material, I never want to take it off 😜",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/52354fb4c14a454ca95e0bd47a5e8059.jpg?w=3000&h=4000"
    ],
    "productTitle": "Poppies Sweatshirt",
    "productHandle": "poppies-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/18a97ee2f14c492783bee1c032b7b3b3.jpg?v=1791470892",
    "productUrl": "/products/poppies-sweatshirt"
  },
  {
    "id": "6a9a33dd8b011d27db23907a",
    "author": "M**n",
    "rating": 5,
    "date": "2026-09-04",
    "content": "Love everything I buy here. Great quality. Inside is simple, not fuzzy. Design is great and good quality",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/6294f8865418444dad6a640b856b0713.jpg?w=3000&h=4000"
    ],
    "productTitle": "Full of Anxiety and Microplastics T-shirt",
    "productHandle": "full-of-anxiety-and-microplastics-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/18-79.jpg?v=1791470899",
    "productUrl": "/products/full-of-anxiety-and-microplastics-t-shirt"
  },
  {
    "id": "6a99b9c16b77867da04d80fa",
    "author": "F**n",
    "rating": 5,
    "date": "2026-09-03",
    "content": "I love this shirt, and I love Jimothy 🦝 My raccoon friends also love it! It’s very comfortable, and very good quality. I plan to buy more for my friends and family, definitely worth the purchase!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/0c9131f4fe7746c8b6fec1f493109f30.jpeg?w=2316&h=3088",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/7ffeee69c32c4b65a07776ccd1a5c971.jpeg?w=623&h=1020"
    ],
    "productTitle": "Full of Anxiety and Microplastics T-shirt",
    "productHandle": "full-of-anxiety-and-microplastics-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/18-79.jpg?v=1791470899",
    "productUrl": "/products/full-of-anxiety-and-microplastics-t-shirt"
  },
  {
    "id": "6a99a0d56b77867da04d80d6",
    "author": "C**n",
    "rating": 5,
    "date": "2026-09-03",
    "content": "Love it. It's my life.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/70859516448d4909bbd3f8819ac89683.jpeg?w=1998&h=3625"
    ],
    "productTitle": "Raccoon Respectfully No T-shirt",
    "productHandle": "raccoon-respectfully-no-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/17-97.jpg?v=1791470905",
    "productUrl": "/products/raccoon-respectfully-no-t-shirt"
  },
  {
    "id": "6a9987746b77867da04d808b",
    "author": "S**r",
    "rating": 5,
    "date": "2026-09-03",
    "content": "Great quality, love the boxier fit, cute design. Literally starting my next order 🥰",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/c509f5ee675747ebac9b16efc7cd55d2.jpg?w=863&h=836"
    ],
    "productTitle": "Raccoon Respectfully No T-shirt",
    "productHandle": "raccoon-respectfully-no-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/17-97.jpg?v=1791470905",
    "productUrl": "/products/raccoon-respectfully-no-t-shirt"
  },
  {
    "id": "67c9b6a8cae9c61ba2b13f08",
    "author": "V**h",
    "rating": 5,
    "date": "2025-03-06",
    "content": "Perfect, I love the t-shirt and the cotton",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/5cc279f120914c5e8137ba110ae4108a.jpeg?w=1241&h=1500"
    ],
    "productTitle": "Meowdy Partner Cowboy Cat T-Shirt",
    "productHandle": "meowdy-partner-cowboy-cat-t-shirt-1",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/4564-0.jpg?v=1791470912",
    "productUrl": "/products/meowdy-partner-cowboy-cat-t-shirt-1"
  },
  {
    "id": "6a9975578b011d27db238f51",
    "author": "W**y",
    "rating": 5,
    "date": "2026-09-03",
    "content": "I Love this tee shirt!!!!!\nOne of my faves!!!!\nThanks\nWilliam",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/cba72befa46140b5bc98e304e00755ea.jpg?w=3060&h=4080"
    ],
    "productTitle": "Meowdy Partner Cowboy Cat T-Shirt",
    "productHandle": "meowdy-partner-cowboy-cat-t-shirt-1",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/4564-0.jpg?v=1791470912",
    "productUrl": "/products/meowdy-partner-cowboy-cat-t-shirt-1"
  },
  {
    "id": "6a981e228b011d27db238d49",
    "author": "B**n",
    "rating": 5,
    "date": "2026-09-02",
    "content": "Got this for the boyfriend and he loves it!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/ee649a3caef448bc8420db9d0ae8de5d.jpg?w=3024&h=4032"
    ],
    "productTitle": "Embroidered Duck T-shirt",
    "productHandle": "embroidered-duck-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/28-_15.jpg?v=1791471138",
    "productUrl": "/products/embroidered-duck-t-shirt"
  },
  {
    "id": "6a9573c16b77867da04d7a2a",
    "author": "C**i",
    "rating": 5,
    "date": "2026-08-31",
    "content": "In love with Jimothy and absolutely adored this print. The quality of the tshirt material is amazing! Extremely happy with my purchase and I may have added an extra tshirt to my cart because there are so many great designs.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/06a96fdf436842a6bb6c0e27e306b967.jpeg?w=4032&h=3024"
    ],
    "productTitle": "Embroidered Duck T-shirt",
    "productHandle": "embroidered-duck-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/28-_15.jpg?v=1791471138",
    "productUrl": "/products/embroidered-duck-t-shirt"
  },
  {
    "id": "6a9573518b011d27db238998",
    "author": "S**n",
    "rating": 5,
    "date": "2026-08-31",
    "content": "Great T-Shirt",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/0e331971e6b540f78805cd5edf78f91a.jpg?w=2544&h=3392"
    ],
    "productTitle": "Embroidered Overstimulated T-shirt",
    "productHandle": "embroidered-overstimulated-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20240821172410_1.jpg?v=1791471143",
    "productUrl": "/products/embroidered-overstimulated-t-shirt"
  },
  {
    "id": "6a95720f6b77867da04d7a28",
    "author": "S**n",
    "rating": 5,
    "date": "2026-08-31",
    "content": "T-shirt is great \nVery funny logo and great material !",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/1fd5402408e144369d63f17252639c36.jpg?w=4000&h=3000"
    ],
    "productTitle": "Embroidered Overstimulated T-shirt",
    "productHandle": "embroidered-overstimulated-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20240821172410_1.jpg?v=1791471143",
    "productUrl": "/products/embroidered-overstimulated-t-shirt"
  },
  {
    "id": "6a943a376b77867da04d787d",
    "author": "A**n",
    "rating": 5,
    "date": "2026-08-30",
    "content": "Excellent quality t-shirt and design: it's already received compliments from fellow film fans 😄",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/0ff65228367b4f0182b4a6c82e47428b.jpg?w=1836&h=3264"
    ],
    "productTitle": "Embroidered PE Teacher Goose T-shirt",
    "productHandle": "embroidered-pe-teacher-goose-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260924145625-4276-1.png?v=1791471149",
    "productUrl": "/products/embroidered-pe-teacher-goose-t-shirt"
  },
  {
    "id": "6a90cbf26b77867da04d73cf",
    "author": "J**e",
    "rating": 5,
    "date": "2026-08-27",
    "content": "Nice thick tshirt. Paired it with a leopard maxi skirt and white sneakers to work today because it’s so cute and Jimothy is a treasure",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/c30d7d6b397c44688f1d2f81d1cc536f.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Embroidered PE Teacher Goose T-shirt",
    "productHandle": "embroidered-pe-teacher-goose-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260924145625-4276-1.png?v=1791471149",
    "productUrl": "/products/embroidered-pe-teacher-goose-t-shirt"
  },
  {
    "id": "6a90a9406b77867da04d73ab",
    "author": "M** ",
    "rating": 5,
    "date": "2026-08-27",
    "content": "Beautiful shirt. The size is perfect.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/86a0b7d8e8594562b83b0e3516b4d5a0.jpg?w=2215&h=3271"
    ],
    "productTitle": "Embroidered Fall Crewneck T-shirt",
    "productHandle": "embroidered-fall-crewneck-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260918150440-4183-1.png?v=1791471156",
    "productUrl": "/products/embroidered-fall-crewneck-t-shirt"
  },
  {
    "id": "6a906d3f6b77867da04d735c",
    "author": "T**o",
    "rating": 5,
    "date": "2026-08-27",
    "content": "I don’t generally buy stuff from instagram but this shirt absolutely delivers! Size is a little tiny small for a medium but still ok for me but quality is superb. Really happy with it",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/f6ac2fedd3b84a89b55690ed529c513c.jpg?w=3024&h=4032",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/c2342ae8f657495ebbea9eb4b52c09a4.jpeg?w=1206&h=1274"
    ],
    "productTitle": "Embroidered Fall Crewneck T-shirt",
    "productHandle": "embroidered-fall-crewneck-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260918150440-4183-1.png?v=1791471156",
    "productUrl": "/products/embroidered-fall-crewneck-t-shirt"
  },
  {
    "id": "6a9002358b011d27db2381eb",
    "author": "C**s",
    "rating": 5,
    "date": "2026-08-27",
    "content": "I absolutely LOVE the tortie t shirt. The quality is fantastic and the print is gorgeous. It looks exactly like my cat. 10/10 would recommend.\n\nI would say maybe size up if you like your t shirts extra baggy. I am a size 12/14 and like my t shirts oversized so I would order an XL next time rather than a L.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/5ff4845ffad74bd6a6be6cc588292d64.jpg?w=2118&h=2771"
    ],
    "productTitle": "Embroidered Halloween Goose Sweatshirt",
    "productHandle": "embroidered-halloween-goose-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260918150436-4179-1.png?v=1791471162",
    "productUrl": "/products/embroidered-halloween-goose-sweatshirt"
  },
  {
    "id": "6a8d57f1bd508304f875e826",
    "author": "L**i",
    "rating": 5,
    "date": "2026-08-25",
    "content": "The product is of good quality and matches what was shown in the catalog. The image and text are perhaps larger than I had imagined. Good delivery times. Overall, a recommended product!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/1172f97c25644a27a35ac6cbd6f260e9.jpg?w=3000&h=4000"
    ],
    "productTitle": "Embroidered Halloween Goose Sweatshirt",
    "productHandle": "embroidered-halloween-goose-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260918150436-4179-1.png?v=1791471162",
    "productUrl": "/products/embroidered-halloween-goose-sweatshirt"
  },
  {
    "id": "6a8d1021c413ecbfbfa59487",
    "author": "M**H",
    "rating": 5,
    "date": "2026-08-25",
    "content": "Love it! Plus great customer service! When my other order was too small, they quickly resolved the issue and sent me a size larger. Long live Jimothy 🦝",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/81ccf0fe3530442bbad3d96d1a4e2af4.jpg?w=3024&h=4032"
    ],
    "productTitle": "Embroidered Black Cat Pumpkin Sweatshirt",
    "productHandle": "embroidered-black-cat-pumpkin-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260917150554-4151-1.png?v=1791471168",
    "productUrl": "/products/embroidered-black-cat-pumpkin-sweatshirt"
  },
  {
    "id": "6a8c4812c413ecbfbfa5935d",
    "author": "M**n",
    "rating": 5,
    "date": "2026-08-24",
    "content": "My daughter loves hers!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/cb9b36105b14488982108054e8cdf353.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Embroidered Black Cat Pumpkin Sweatshirt",
    "productHandle": "embroidered-black-cat-pumpkin-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260917150554-4151-1.png?v=1791471168",
    "productUrl": "/products/embroidered-black-cat-pumpkin-sweatshirt"
  },
  {
    "id": "6a8bf5f2c413ecbfbfa592d3",
    "author": "M**",
    "rating": 5,
    "date": "2026-08-24",
    "content": "​I'm super satisfied with this purchase! The t-shirt looks exactly as shown in the pictures, and the print quality is great.\n​I bought a size M.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/c37e4792bf2849dc94e3ea052d3c5a04.jpg?w=3000&h=4000",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/4ac4726e29144ccfacb96d26635a2280.jpg?w=3000&h=4000",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/620c2cd60b1345e6980449b19b41d3fb.jpg?w=3000&h=4000",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/d7ec91e6a4304b50b8b2996ea57372da.jpg?w=3000&h=4000"
    ],
    "productTitle": "Embroidered Spooky Village Sweatshirt",
    "productHandle": "embroidered-spooky-village-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/12-727.jpg?v=1791471173",
    "productUrl": "/products/embroidered-spooky-village-sweatshirt"
  },
  {
    "id": "6a8bf442c413ecbfbfa592d0",
    "author": "M**k",
    "rating": 5,
    "date": "2026-08-24",
    "content": "​I am very satisfied with this purchase! The t-shirt looks exactly like in the product photos, and the print quality is really good.\n\n​I bought a size M,so you can check the actual dimensions.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/01cb905630534f00bb3cac1ed615d152.jpg?w=3000&h=4000",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/61f8a5c6326141c2aab743042d37539a.jpg?w=3000&h=4000",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/2ab0a3f251c445cfb8eeba7b73b4b574.jpg?w=3000&h=4000",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/9961587533a04841aa097a33aa0b0335.jpg?w=3000&h=4000"
    ],
    "productTitle": "Embroidered Spooky Village Sweatshirt",
    "productHandle": "embroidered-spooky-village-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/12-727.jpg?v=1791471173",
    "productUrl": "/products/embroidered-spooky-village-sweatshirt"
  },
  {
    "id": "6a8bd16ebd508304f875e5c6",
    "author": "R**Z",
    "rating": 5,
    "date": "2026-08-24",
    "content": "I love my shirt!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/6f4d21026c5e43a890d8b9ed800e1d81.jpg?w=2544&h=3392"
    ],
    "productTitle": "Halloween Icons Embroidered T-shirt",
    "productHandle": "halloween-icons-embroidered-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/halloween-_2_-0.jpg?v=1791471179",
    "productUrl": "/products/halloween-icons-embroidered-t-shirt"
  },
  {
    "id": "6a8b453dc413ecbfbfa591e9",
    "author": "G**r",
    "rating": 5,
    "date": "2026-08-23",
    "content": "I love my Jimothy tee! I get comments everywhere I go!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/520f032247aa408caeef534326477f50.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Halloween Icons Embroidered T-shirt",
    "productHandle": "halloween-icons-embroidered-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/halloween-_2_-0.jpg?v=1791471179",
    "productUrl": "/products/halloween-icons-embroidered-t-shirt"
  },
  {
    "id": "6a8a5f2cc413ecbfbfa5907a",
    "author": "A**l",
    "rating": 5,
    "date": "2026-08-23",
    "content": "Obsessed is an understatement!! I love the color!!! The fit is nice and oversized and realllllll cotton!!!! 10/10",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/e63eb68e1ef54ba09f4d654e965e7c2e.jpeg?w=1242&h=2208"
    ],
    "productTitle": "Halloween Goose Embroidered T-shirt",
    "productHandle": "halloween-goose-embroidered-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/halloween-_4_-1.jpg?v=1791471187",
    "productUrl": "/products/halloween-goose-embroidered-t-shirt"
  },
  {
    "id": "6a8a5269bd508304f875e3a7",
    "author": "R**e",
    "rating": 5,
    "date": "2026-08-23",
    "content": "I was so pissed cause I saw this tshirt and had to have it. Ordered it and thought I got scammed. Nope. Tshirt came and I live it.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/41029786753643a5896de1af265a1e62.jpg?w=3024&h=4032"
    ],
    "productTitle": "Halloween Goose Embroidered T-shirt",
    "productHandle": "halloween-goose-embroidered-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/halloween-_4_-1.jpg?v=1791471187",
    "productUrl": "/products/halloween-goose-embroidered-t-shirt"
  },
  {
    "id": "6a88b08abd508304f875e183",
    "author": "S**g",
    "rating": 5,
    "date": "2026-08-21",
    "content": "Amazing quality and Jimothy graphics! Looks even better in person. 🦝🎉",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/6e77b235fb3549d595b452ebb7e7734a.jpeg?w=2622&h=2974"
    ],
    "productTitle": "Embroidered Spooky Season Witchy Movie Sweatshirt",
    "productHandle": "embroidered-spooky-season-witchy-movie-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/edc747ce849691d064d1b19cbd6163d4.jpg?v=1791471193",
    "productUrl": "/products/embroidered-spooky-season-witchy-movie-sweatshirt"
  },
  {
    "id": "6a884d62bd508304f875e0d5",
    "author": "J**y",
    "rating": 5,
    "date": "2026-08-21",
    "content": "Honestly, I was surprised at the quality of this shirt.  The graphic is beautiful and I love it.  Looks perfectly “worn” too.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/361bcc596bd048c7903468ab175d1a73.jpeg?w=556&h=977"
    ],
    "productTitle": "Embroidered Spooky Season Witchy Movie Sweatshirt",
    "productHandle": "embroidered-spooky-season-witchy-movie-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/edc747ce849691d064d1b19cbd6163d4.jpg?v=1791471193",
    "productUrl": "/products/embroidered-spooky-season-witchy-movie-sweatshirt"
  },
  {
    "id": "6a8839dfc413ecbfbfa58db3",
    "author": "K**c",
    "rating": 5,
    "date": "2026-08-21",
    "content": "Love this shirt and I won the Mahjong tournament the day I wore it!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/df1cebd3d5074a6cbe25d3bae1696bd1.jpeg?w=1406&h=3053"
    ],
    "productTitle": "Embroidered Spooky Village Sweatshirt",
    "productHandle": "embroidered-spooky-village-sweatshirt-1",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/729a0ffa07bdd425d1acb3cb202d4c5e.jpg?v=1791471198",
    "productUrl": "/products/embroidered-spooky-village-sweatshirt-1"
  },
  {
    "id": "6a87dce6c413ecbfbfa58d3f",
    "author": "M**d",
    "rating": 5,
    "date": "2026-08-21",
    "content": "Great shirt! Nice quality and fits well.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/291cc7b4f27848b7806843ae492029da.jpg?w=2736&h=3648"
    ],
    "productTitle": "Embroidered Spooky Village Sweatshirt",
    "productHandle": "embroidered-spooky-village-sweatshirt-1",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/729a0ffa07bdd425d1acb3cb202d4c5e.jpg?v=1791471198",
    "productUrl": "/products/embroidered-spooky-village-sweatshirt-1"
  },
  {
    "id": "6a871e15bd508304f875df1e",
    "author": "E**s",
    "rating": 5,
    "date": "2026-08-20",
    "content": "Sunflowers are one of my favourite flowers. So I had to add this awesome design to my collection,",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/d50033662bd9424fb90d17e9db12c412.jpg?w=2448&h=3079"
    ],
    "productTitle": "Embroidered Fall Ghost Sweatshirt",
    "productHandle": "embroidered-fall-ghost-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/5512472827a85e238020b3344a3a5abe.jpg?v=1791471203",
    "productUrl": "/products/embroidered-fall-ghost-sweatshirt"
  },
  {
    "id": "6a856960df398e937ca77d01",
    "author": "J**k",
    "rating": 5,
    "date": "2026-08-19",
    "content": "I love my Rocky tee shirt. I also bought one for a friend and she loves it too. Highly recommended",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/146096323f4847a0a5ecda5acca852c3.jpg?w=2268&h=3024"
    ],
    "productTitle": "Embroidered Fall Ghost Sweatshirt",
    "productHandle": "embroidered-fall-ghost-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/5512472827a85e238020b3344a3a5abe.jpg?v=1791471203",
    "productUrl": "/products/embroidered-fall-ghost-sweatshirt"
  },
  {
    "id": "6a8434aadf398e937ca77b28",
    "author": "B**l",
    "rating": 5,
    "date": "2026-08-18",
    "content": "Love this shirt, fits amazing, comfy, nice material.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/490a935c976c40b790c99a1d631fba85.jpeg?w=4284&h=3300"
    ],
    "productTitle": "Fun Aunt Knight Riding Black Cat T-shirt",
    "productHandle": "fun-aunt-knight-riding-black-cat-t-shirt-1",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260729151611-3271-1_4585a510-544c-44bb-a12e-925d05abf3ae.png?v=1791471541",
    "productUrl": "/products/fun-aunt-knight-riding-black-cat-t-shirt-1"
  },
  {
    "id": "6a83ab382108f1317fbd01e6",
    "author": "A**o",
    "rating": 5,
    "date": "2026-08-18",
    "content": "Comfortable and I wear it all the time. Won’t be my last order.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/fb3a062381394a939d533f6faedf7ab5.jpeg?w=2920&h=2274"
    ],
    "productTitle": "Fun Aunt Knight Riding Black Cat T-shirt",
    "productHandle": "fun-aunt-knight-riding-black-cat-t-shirt-1",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260729151611-3271-1_4585a510-544c-44bb-a12e-925d05abf3ae.png?v=1791471541",
    "productUrl": "/products/fun-aunt-knight-riding-black-cat-t-shirt-1"
  },
  {
    "id": "6a838b03df398e937ca77a28",
    "author": "A**s",
    "rating": 5,
    "date": "2026-08-17",
    "content": "The material feels quite spectacular and soft:))\nI bought two \nMy fiancé and I are in love with these shirts🥲",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/ca2f2e560efe44c59442582740580de8.jpg?w=4032&h=3024"
    ],
    "productTitle": "Vintage Tabby Cat Resist T-shirt",
    "productHandle": "vintage-tabby-cat-resist-t-shirt-1",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/6420af910a1fe849592e24963e7d20cb_6ec48a2a-ec79-4216-bfae-7a09ceb44898.jpg?v=1791471553",
    "productUrl": "/products/vintage-tabby-cat-resist-t-shirt-1"
  },
  {
    "id": "6a8360842108f1317fbd017c",
    "author": "S**n",
    "rating": 5,
    "date": "2026-08-17",
    "content": "Great quality shirt!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/8ec28c6ec79249fda11408f57532edd1.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Vintage Tabby Cat Resist T-shirt",
    "productHandle": "vintage-tabby-cat-resist-t-shirt-1",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/6420af910a1fe849592e24963e7d20cb_6ec48a2a-ec79-4216-bfae-7a09ceb44898.jpg?v=1791471553",
    "productUrl": "/products/vintage-tabby-cat-resist-t-shirt-1"
  },
  {
    "id": "6a82fd392108f1317fbd00d4",
    "author": "M**r",
    "rating": 5,
    "date": "2026-08-17",
    "content": "love the tshirt! very comfortable and good quality. first wash showed no color alteration. work mates were amaze(d) amaze(d) amaze(d) ;-)",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/8a3c076aa40f4976bc6b7f2384891b5d.jpg?w=2316&h=3088"
    ],
    "productTitle": "Cat Carrying Alien T-Shirt",
    "productHandle": "cat-carrying-alien-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/13-472.jpg?v=1791471560",
    "productUrl": "/products/cat-carrying-alien-t-shirt"
  },
  {
    "id": "6a82d751df398e937ca7791e",
    "author": "M**i",
    "rating": 5,
    "date": "2026-08-17",
    "content": "Mi rispecchia perfettamente! Bellissima",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/f31d38c1b3e54a58a5ceacdc5a57a783.jpg?w=3096&h=4128"
    ],
    "productTitle": "Cat Carrying Alien T-Shirt",
    "productHandle": "cat-carrying-alien-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/13-472.jpg?v=1791471560",
    "productUrl": "/products/cat-carrying-alien-t-shirt"
  },
  {
    "id": "6a733b570b445406e80ca333",
    "author": "D**e",
    "rating": 5,
    "date": "2026-08-05",
    "content": "Due to the heatwave my penchant this summer has been to lop off t shirt sleeves willy nilly and it looks great on this item. Genuine grunge look. Would say they’re oversized tho - a small was nearer a medium on me. Really good quality cotton and a well made item. Would recommend highly",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/27bd9ca69644445687fd3f49486bca1e.jpeg?w=3020&h=4028"
    ],
    "productTitle": "Cat Says No Thanks Funny T-shirt",
    "productHandle": "cat-says-no-thanks-funny-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/07-151.jpg?v=1791471566",
    "productUrl": "/products/cat-says-no-thanks-funny-t-shirt"
  },
  {
    "id": "6a82b6fbdf398e937ca778f6",
    "author": "K**y",
    "rating": 5,
    "date": "2026-08-17",
    "content": "Great quality shirt",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/7dd68e1838b3400ba1330e37d17ca2bf.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Cat Says No Thanks Funny T-shirt",
    "productHandle": "cat-says-no-thanks-funny-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/07-151.jpg?v=1791471566",
    "productUrl": "/products/cat-says-no-thanks-funny-t-shirt"
  },
  {
    "id": "6a8238492108f1317fbcff7c",
    "author": "D**s",
    "rating": 5,
    "date": "2026-08-16",
    "content": "I love my new shirt! The material is soft and comfy. I bought a size small. I cut off the bottom to make it waist length and it turned out cute. I also bought another shirt in large and love to wear it with leggings.  I’m 5’2 and I weigh 126.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/64d7034e05d04eda9ebae6de0cd09d1e.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Vintage Skateboarding Cat T-shirt",
    "productHandle": "vintage-skateboarding-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/6-1779.jpg?v=1791471571",
    "productUrl": "/products/vintage-skateboarding-cat-t-shirt"
  },
  {
    "id": "6a81cc79df398e937ca77764",
    "author": "s**e",
    "rating": 5,
    "date": "2026-08-16",
    "content": "Love them T-shirts! My son and I have matching ones and we love them!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/8514e8319e3d47d5b9a180df4954a62f.jpg?w=588&h=441"
    ],
    "productTitle": "Vintage Skateboarding Cat T-shirt",
    "productHandle": "vintage-skateboarding-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/6-1779.jpg?v=1791471571",
    "productUrl": "/products/vintage-skateboarding-cat-t-shirt"
  },
  {
    "id": "6a8165272108f1317fbcfe69",
    "author": "S**e",
    "rating": 5,
    "date": "2026-08-16",
    "content": "Soft comfortable and beautiful pattern",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/7bb477aab2e8482fbe8ce4602fbc6263.jpeg?w=1600&h=1200"
    ],
    "productTitle": "Cat Vinyl Record Player Rock T-shirt",
    "productHandle": "cat-vinyl-record-player-rock-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260818143601-3593-1.png?v=1791471577",
    "productUrl": "/products/cat-vinyl-record-player-rock-t-shirt"
  },
  {
    "id": "6a7d43e3df398e937ca7714c",
    "author": "w**l",
    "rating": 5,
    "date": "2026-08-13",
    "content": "everyone who has seen it has complimented me on it, and its soft 👍",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/d02041f1ad35415ea0a53eeab55a18d0.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Cat Vinyl Record Player Rock T-shirt",
    "productHandle": "cat-vinyl-record-player-rock-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260818143601-3593-1.png?v=1791471577",
    "productUrl": "/products/cat-vinyl-record-player-rock-t-shirt"
  },
  {
    "id": "6a9975578b011d27db238f51",
    "author": "W**y",
    "rating": 5,
    "date": "2026-09-03",
    "content": "I Love this tee shirt!!!!!\nOne of my faves!!!!\nThanks\nWilliam",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/cba72befa46140b5bc98e304e00755ea.jpg?w=3060&h=4080"
    ],
    "productTitle": "Rock Star Cat T-Shirt",
    "productHandle": "rock-star-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260721152931-456-14.jpg?v=1791471582",
    "productUrl": "/products/rock-star-cat-t-shirt"
  },
  {
    "id": "6a7d2c182108f1317fbcf8dd",
    "author": "A**z",
    "rating": 5,
    "date": "2026-08-13",
    "content": "Fits great. High quality. So many compliments and likes first day wearing it. Shipping had a snag but company/seller was so responsive and helped fix the address issues. First time buying anything off IG and can’t wait to get some more! Thanks again Rusty Fox Co.! I will shenan again!! 😂",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/8b656ad584554494af8720cba40d941a.jpg?w=3024&h=4032"
    ],
    "productTitle": "Rock Star Cat T-Shirt",
    "productHandle": "rock-star-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260721152931-456-14.jpg?v=1791471582",
    "productUrl": "/products/rock-star-cat-t-shirt"
  },
  {
    "id": "6a9002358b011d27db2381eb",
    "author": "C**s",
    "rating": 5,
    "date": "2026-08-27",
    "content": "I absolutely LOVE the tortie t shirt. The quality is fantastic and the print is gorgeous. It looks exactly like my cat. 10/10 would recommend.\n\nI would say maybe size up if you like your t shirts extra baggy. I am a size 12/14 and like my t shirts oversized so I would order an XL next time rather than a L.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/5ff4845ffad74bd6a6be6cc588292d64.jpg?w=2118&h=2771"
    ],
    "productTitle": "Tortoiseshell Cat Howling to the Moon T-shirt",
    "productHandle": "tortoiseshell-cat-howling-to-the-moon-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/lQDPJwsb1plShXvNA3jNA3iwe4LrLRe1KPcJ-c-LCKVxAg-888-888.jpg?v=1791471587",
    "productUrl": "/products/tortoiseshell-cat-howling-to-the-moon-t-shirt"
  },
  {
    "id": "6a7cd2022108f1317fbcf849",
    "author": "P**l",
    "rating": 5,
    "date": "2026-08-12",
    "content": "I absolutely love this t shirt and have been asked by loads of people where to get one",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/bbb136a4ba7c433b81e13f7fdcb9fbf9.jpg?w=1563&h=1464"
    ],
    "productTitle": "Tortoiseshell Cat Howling to the Moon T-shirt",
    "productHandle": "tortoiseshell-cat-howling-to-the-moon-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/lQDPJwsb1plShXvNA3jNA3iwe4LrLRe1KPcJ-c-LCKVxAg-888-888.jpg?v=1791471587",
    "productUrl": "/products/tortoiseshell-cat-howling-to-the-moon-t-shirt"
  },
  {
    "id": "6a7c7601df398e937ca77023",
    "author": "A**r",
    "rating": 5,
    "date": "2026-08-12",
    "content": "I love my new Neil the Seal shirt! It’s so soft & has a great design, The shipping was quicker than I expected. Great shopping experience.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/92bfdeae5c3c4530920bd6adad6e8955.jpeg?w=3030&h=3426"
    ],
    "productTitle": "Rage Consumes Me T-shirt/Sweatshirt",
    "productHandle": "rage-consumes-me-t-shirt-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/24-_16.jpg?v=1791471598",
    "productUrl": "/products/rage-consumes-me-t-shirt-sweatshirt"
  },
  {
    "id": "6a7c63d4df398e937ca76fe1",
    "author": "L**n",
    "rating": 5,
    "date": "2026-08-12",
    "content": "I LOVE MY SHIRT its so cute and the quality is great",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/eb0ecd76cc424403a17befaa5a5afc3c.jpg?w=1080&h=1133"
    ],
    "productTitle": "Rage Consumes Me T-shirt/Sweatshirt",
    "productHandle": "rage-consumes-me-t-shirt-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/24-_16.jpg?v=1791471598",
    "productUrl": "/products/rage-consumes-me-t-shirt-sweatshirt"
  },
  {
    "id": "6a9c71ff6b77867da04d84c6",
    "author": "A**H",
    "rating": 5,
    "date": "2026-09-05",
    "content": "The best of my « summer T shirts » !!!!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/96d8ace9765b454f9617e213e59a7d73.jpeg?w=4032&h=3024"
    ],
    "productTitle": "Japanese Minimalist 1950s Retro Space Cat Good Luck Kanji T-shirt",
    "productHandle": "japanese-minimalist-1950s-retro-space-cat-good-luck-kanji-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260526141801-1926-1.png?v=1791471605",
    "productUrl": "/products/japanese-minimalist-1950s-retro-space-cat-good-luck-kanji-t-shirt"
  },
  {
    "id": "6a510c3d1e439e7bc4378123",
    "author": "K**e",
    "rating": 5,
    "date": "2026-07-10",
    "content": "Hi quality, size is accurate, I love it !",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/09fabe0bbfb34e439b9908efb525dbe3.jpg?w=2316&h=3088",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/e2bab1871fc046b9b076833b65cab50f.jpg?w=2316&h=3088"
    ],
    "productTitle": "Japanese Minimalist 1950s Retro Space Cat Good Luck Kanji T-shirt",
    "productHandle": "japanese-minimalist-1950s-retro-space-cat-good-luck-kanji-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260526141801-1926-1.png?v=1791471605",
    "productUrl": "/products/japanese-minimalist-1950s-retro-space-cat-good-luck-kanji-t-shirt"
  },
  {
    "id": "69e03ba5f1da2a12590d1900",
    "author": "S**h",
    "rating": 5,
    "date": "2026-04-16",
    "content": "New favorite shirts! The quality of the shirts and print are great! I machine wash and hang dry,I will be ordering again. So many great designs to choose from!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/37661f19e3b44df1ba1c85aaa5ed5292.jpg?w=2992&h=2992"
    ],
    "productTitle": "Cool DJ Cat T-shirt",
    "productHandle": "cool-dj-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/24-_54.jpg?v=1791471610",
    "productUrl": "/products/cool-dj-cat-t-shirt"
  },
  {
    "id": "698cbd18ca84e3db64bbbe60",
    "author": "R**n",
    "rating": 5,
    "date": "2026-02-11",
    "content": "Exceptionally well-made with clear, colorful graphics, quality cotton and I’m SO glad it’s screened, as opposed to plastic appliqués. I can tell this shirt will last a decade or more. Very pleased!!! ❤️ 🐈‍⬛",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/b4e529494e944bf491d57175f38b6960.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Cool DJ Cat T-shirt",
    "productHandle": "cool-dj-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/24-_54.jpg?v=1791471610",
    "productUrl": "/products/cool-dj-cat-t-shirt"
  },
  {
    "id": "6a7c22812108f1317fbcf711",
    "author": "M**i",
    "rating": 5,
    "date": "2026-08-12",
    "content": "La adoro!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/6bc7c0d180894676bd810ec4345928d9.jpg?w=3096&h=4128"
    ],
    "productTitle": "Tortoiseshell Cat Howling to the Moon T-shirt",
    "productHandle": "tortoiseshell-cat-howling-to-the-moon-t-shirt-1",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260609140702-2261-1.png?v=1791471616",
    "productUrl": "/products/tortoiseshell-cat-howling-to-the-moon-t-shirt-1"
  },
  {
    "id": "6a7a3ae42108f1317fbcf440",
    "author": "M**s",
    "rating": 5,
    "date": "2026-08-10",
    "content": "This was a birthday gift and she loved it. THE quality of the shirt was very good, the image clear. I may just order one for my self",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/27d3bcad73814709ae37f7016c16e36f.jpg?w=3000&h=4000"
    ],
    "productTitle": "Tortoiseshell Cat Howling to the Moon T-shirt",
    "productHandle": "tortoiseshell-cat-howling-to-the-moon-t-shirt-1",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/20260609140702-2261-1.png?v=1791471616",
    "productUrl": "/products/tortoiseshell-cat-howling-to-the-moon-t-shirt-1"
  },
  {
    "id": "6a787f4c2108f1317fbcf125",
    "author": "C** ",
    "rating": 5,
    "date": "2026-08-09",
    "content": "One of my best Shirts. I love that quality 👌",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/5800f6ccf1984d15b7f971183d655511.jpg?w=2544&h=3392"
    ],
    "productTitle": "Vintage Funny Cat T-shirt",
    "productHandle": "vintage-funny-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/9-121.jpg?v=1791471622",
    "productUrl": "/products/vintage-funny-cat-t-shirt"
  },
  {
    "id": "6a787d59df398e937ca769d6",
    "author": "M**n",
    "rating": 5,
    "date": "2026-08-09",
    "content": "I was surprised how great was the fit and material also! I surely love this!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/10adee9724c44c3698867ff04fbfbb09.jpg?w=1080&h=1920"
    ],
    "productTitle": "Vintage Funny Cat T-shirt",
    "productHandle": "vintage-funny-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/9-121.jpg?v=1791471622",
    "productUrl": "/products/vintage-funny-cat-t-shirt"
  },
  {
    "id": "6a9d1d848b011d27db2394a9",
    "author": "S**l",
    "rating": 5,
    "date": "2026-09-06",
    "content": "Loved the shirt for the Australian Father’s Day. It’s great how it’s just a good vibe shirt, not even remotely political.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/330dd92ad83a4e40a7cc49f1b1d60c67.png?w=1086&h=1448"
    ],
    "productTitle": "Funny Boy Mom Goose T-shirt",
    "productHandle": "funny-boy-mom-goose-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/lQDPJwvHu3elqIHNA3jNA3iwuZX492Af96kJxl2N0Bx6AA-888-888.jpg?v=1791471822",
    "productUrl": "/products/funny-boy-mom-goose-t-shirt"
  },
  {
    "id": "6a786ab62108f1317fbcf107",
    "author": "S**r",
    "rating": 5,
    "date": "2026-08-09",
    "content": "I love this shirt! It gets giggles 😁",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/4daf4695395a4af98aee3b7752e31b8c.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Funny Boy Mom Goose T-shirt",
    "productHandle": "funny-boy-mom-goose-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/lQDPJwvHu3elqIHNA3jNA3iwuZX492Af96kJxl2N0Bx6AA-888-888.jpg?v=1791471822",
    "productUrl": "/products/funny-boy-mom-goose-t-shirt"
  },
  {
    "id": "6a77c48ddf398e937ca768d6",
    "author": "K**z",
    "rating": 5,
    "date": "2026-08-09",
    "content": "Its nice, cool, awesome shirt. It's soft and it feels good wearing it 😎",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/0d0928ba2878447db4bec98dd068c13d.jpg?w=3000&h=4000"
    ],
    "productTitle": "Overstimulated Moms Club T-shirt",
    "productHandle": "overstimulated-moms-club-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_52.jpg?v=1791471829",
    "productUrl": "/products/overstimulated-moms-club-t-shirt"
  },
  {
    "id": "6a7671a2df398e937ca76718",
    "author": "L**s",
    "rating": 5,
    "date": "2026-08-08",
    "content": "love my Neil the seal shirt!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/4b328f84794247468d92fc47f7894527.jpg?w=2610&h=4640"
    ],
    "productTitle": "Overstimulated Moms Club T-shirt",
    "productHandle": "overstimulated-moms-club-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_52.jpg?v=1791471829",
    "productUrl": "/products/overstimulated-moms-club-t-shirt"
  },
  {
    "id": "6a733b570b445406e80ca333",
    "author": "D**e",
    "rating": 5,
    "date": "2026-08-05",
    "content": "Due to the heatwave my penchant this summer has been to lop off t shirt sleeves willy nilly and it looks great on this item. Genuine grunge look. Would say they’re oversized tho - a small was nearer a medium on me. Really good quality cotton and a well made item. Would recommend highly",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/27bd9ca69644445687fd3f49486bca1e.jpeg?w=3020&h=4028"
    ],
    "productTitle": "90’S Mom Vibes T-shirt",
    "productHandle": "90-s-mom-vibes-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_1.jpg?v=1791471835",
    "productUrl": "/products/90-s-mom-vibes-t-shirt"
  },
  {
    "id": "6a732c2f162dddc3fdca7e20",
    "author": "K**n",
    "rating": 5,
    "date": "2026-08-05",
    "content": "LOVE this shirt, comfortable, washed well, not suffocating and absolutely ADORABLE graphic. I will take some points for creativity though; you guys missed an opportunity to make the frog a little toad and say “TOADALLY born to Dilly Dally” lol Anywhoo, I love it and will probably purchase more.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/2f2cf4da7c2b4efbab70c8d3941e9720.jpeg?w=1242&h=2208"
    ],
    "productTitle": "90’S Mom Vibes T-shirt",
    "productHandle": "90-s-mom-vibes-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_1.jpg?v=1791471835",
    "productUrl": "/products/90-s-mom-vibes-t-shirt"
  },
  {
    "id": "6a727e390b445406e80ca1b3",
    "author": "T**n",
    "rating": 5,
    "date": "2026-08-05",
    "content": "By far the best tshirt I've bought on a whim off a facebook ad (I know, I'm weak lol), in terms of fit and quality. The black cotton feels heavier than the usual I'd come to expect, and has a nice worn effect. The print is of a higher standard, too, and looks like it'll actually last a good few years - again, much better than usual",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/a7399af1344a470b9f29ee2991dfe4f6.jpg?w=3876&h=3000"
    ],
    "productTitle": "Cat Mom T-shirt",
    "productHandle": "cat-mom-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/10-16-6.jpg?v=1791471841",
    "productUrl": "/products/cat-mom-t-shirt"
  },
  {
    "id": "6a6f26370b445406e80c9bc3",
    "author": "W**n",
    "rating": 5,
    "date": "2026-08-02",
    "content": "Bought for a friend's 70th birthday. He loved it! He has a ginger cat & loves science & sci-fi. He is very slight & I was worried it might be too large, but it fits fine. For a more fitted t-shirt I would have bought the Medium. Lovely quality. Was worried it would arrive in time, as am in UK, but arrived the day before. Very good updates on shipment & delivery. Intend to buy. More - for friends and for myself!!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/25b16de9811e495a86252a400de31725.jpg?w=1500&h=2000"
    ],
    "productTitle": "Cat Mom T-shirt",
    "productHandle": "cat-mom-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/10-16-6.jpg?v=1791471841",
    "productUrl": "/products/cat-mom-t-shirt"
  },
  {
    "id": "6a6f0763162dddc3fdca7706",
    "author": "A**R",
    "rating": 5,
    "date": "2026-08-02",
    "content": "Well pleased with the shirt. Very good quality and the message has made people smile.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/056381400fd542c7b7c0150b06917f36.jpg?w=2160&h=3840"
    ],
    "productTitle": "I'm Just Someone's Weird Mom T-shirt",
    "productHandle": "i-x27-m-just-someone-x27-s-weird-mom-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/06-168.jpg?v=1791471846",
    "productUrl": "/products/i-x27-m-just-someone-x27-s-weird-mom-t-shirt"
  },
  {
    "id": "6a6ecd770b445406e80c9b65",
    "author": "V**n",
    "rating": 5,
    "date": "2026-08-02",
    "content": "I have a special relationship to Car Talk.  I was Program Director of WBUR way back then and I found the \"boys\" and had them do the show. I teased them that they owe me a dollar for fame and fortune, and one day at a retirement party, they paid me. \nShirt looks evocative.  I haven't worn it yet.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/192ba46ebd9348268f265bd7866200b8.jpg?w=1137&h=640"
    ],
    "productTitle": "I'm Just Someone's Weird Mom T-shirt",
    "productHandle": "i-x27-m-just-someone-x27-s-weird-mom-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/06-168.jpg?v=1791471846",
    "productUrl": "/products/i-x27-m-just-someone-x27-s-weird-mom-t-shirt"
  },
  {
    "id": "6a6b561a0b445406e80c9666",
    "author": "K**m",
    "rating": 5,
    "date": "2026-07-30",
    "content": "I love all my new shirts from Rusty Fox Co. These are so nicely made the images are going to last forever. The quality of the shirts is so nice.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/bb15ef290ec349b5814c0b8fced2f05e.jpg?w=4000&h=2252",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/bc4f5d5a112c484e82cf4583299e3907.jpg?w=4000&h=2252"
    ],
    "productTitle": "In My Boy Mom Era T-shirt",
    "productHandle": "in-my-boy-mom-era-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/lQDPJyAQCaeJeE3NA3jNA3iww2Xb-cIjiugJ1xqH-Cd4AA-888-888.jpg?v=1791471852",
    "productUrl": "/products/in-my-boy-mom-era-t-shirt"
  },
  {
    "id": "6a69c5990b445406e80c9410",
    "author": "O**d",
    "rating": 5,
    "date": "2026-07-29",
    "content": "Adore this tshirt, its so fun and nostalgic. I received alot of positive comments from it also.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/762e37f535504ffa97dba7e203ac510b.jpg?w=2544&h=2544"
    ],
    "productTitle": "In My Boy Mom Era T-shirt",
    "productHandle": "in-my-boy-mom-era-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/lQDPJyAQCaeJeE3NA3jNA3iww2Xb-cIjiugJ1xqH-Cd4AA-888-888.jpg?v=1791471852",
    "productUrl": "/products/in-my-boy-mom-era-t-shirt"
  },
  {
    "id": "68626df95827735f8eea3c77",
    "author": "Ö**r",
    "rating": 5,
    "date": "2025-06-30",
    "content": "Love it! Good quality and fast delivery.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/589ccc8c1442452eaee7a0559739d040.jpeg?w=3024&h=4032",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/ecc3f596e8644fac8d52d6ade271dcfb.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Feral Moms Social Club T-shirt",
    "productHandle": "feral-moms-social-club-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/24-_27.jpg?v=1791471857",
    "productUrl": "/products/feral-moms-social-club-t-shirt"
  },
  {
    "id": "67a659a9dbd1267139e6a39c",
    "author": "T**d",
    "rating": 5,
    "date": "2025-02-07",
    "content": "I am always skeptical when purchasing items advertised on social media. A Rusty Fox Co. T-shirt site popped up while scrolling and the first shirt I saw was so eye catching, I loved it. I ended up getting two different ones. Praying they would actually arrive and I wouldn't be disappointed by cheap material. Let me tell you, I am so glad I clicked purchase. I received my shirts aprox 1 week after purchase. When I opened them up, I was blown away by the material, it was so soft and comfortable and the shirt designs were exactly as pictured. Im more on the smaller size (5'6 130 lbs) I ordered a medium because I like my shirts loose and was worried as a first time shopper the small would fit too tight. The medium gives me a nice comfortable w a slight over sized look and it is perfect for me. I will def be ordering again.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/ed626174a87b4474b3331f74cc9078f5.jpeg?w=3024&h=4032",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/10a8c4e8a6fe4fecade448a9c4656207.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Feral Moms Social Club T-shirt",
    "productHandle": "feral-moms-social-club-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/24-_27.jpg?v=1791471857",
    "productUrl": "/products/feral-moms-social-club-t-shirt"
  },
  {
    "id": "6a69c5480b445406e80c940f",
    "author": "O**d",
    "rating": 5,
    "date": "2026-07-29",
    "content": "Absolutely love this tshirt, it has all my favourite artists on, it took me back to the 90s. Great customer services and speedy delivery, I even received it in time for my birthday.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/10e98935238a404c8517b42f08e78c45.jpg?w=3000&h=4000"
    ],
    "productTitle": "Mother I Am But Skin And Bones Cat T-shirt",
    "productHandle": "mother-i-am-but-skin-and-bones-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/15-91-1.jpg?v=1791471864",
    "productUrl": "/products/mother-i-am-but-skin-and-bones-cat-t-shirt"
  },
  {
    "id": "6a699af3162dddc3fdca6f68",
    "author": "J**s",
    "rating": 5,
    "date": "2026-07-29",
    "content": "I love it. The t-shirt feels nice and soft. It didn‘t smell bad, I could wear it directly. I got a lot of compliments from my millennials friends 😉",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/51b1085981e1453ab28ada540d885ce3.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Mother I Am But Skin And Bones Cat T-shirt",
    "productHandle": "mother-i-am-but-skin-and-bones-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/15-91-1.jpg?v=1791471864",
    "productUrl": "/products/mother-i-am-but-skin-and-bones-cat-t-shirt"
  },
  {
    "id": "6a6932f40b445406e80c934b",
    "author": "S**t",
    "rating": 5,
    "date": "2026-07-28",
    "content": "Love it! I’m so happy with all of my purchases at Rusty Fox Co.!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/5922e80fceee46bb898c2b0b9dadce21.jpeg?w=718&h=754"
    ],
    "productTitle": "Funny Cat Mom Quote T-shirt",
    "productHandle": "funny-cat-mom-quote-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/1499d6936abc33991a63ef87631b75b9.jpg?v=1791471870",
    "productUrl": "/products/funny-cat-mom-quote-t-shirt"
  },
  {
    "id": "6a6924340b445406e80c9342",
    "author": "S**t",
    "rating": 5,
    "date": "2026-07-28",
    "content": "Absolutely LOVE IT!! I’ve purchased from Rusty Fox Co. before, and they never disappoint!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/e1458815702e46fea70b914d9662d9a0.jpeg?w=737&h=761"
    ],
    "productTitle": "Funny Cat Mom Quote T-shirt",
    "productHandle": "funny-cat-mom-quote-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/1499d6936abc33991a63ef87631b75b9.jpg?v=1791471870",
    "productUrl": "/products/funny-cat-mom-quote-t-shirt"
  },
  {
    "id": "6a68f03a0b445406e80c92f3",
    "author": "A**a",
    "rating": 5,
    "date": "2026-07-28",
    "content": "This t shirt is well made- thick/not see through even though it's white, and doesn't give the cheap vibes. The print is hilarious. Big hit at my girls trip.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/f6ab8c594a3a436a815956e2364558ee.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Overstimulated Dads Club T-shirt",
    "productHandle": "overstimulated-dads-club-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_59.jpg?v=1791471876",
    "productUrl": "/products/overstimulated-dads-club-t-shirt"
  },
  {
    "id": "6a680f3b0b445406e80c911c",
    "author": "J**r",
    "rating": 5,
    "date": "2026-07-28",
    "content": "My new favorite shirt! I ordered a large and it’s so comfy and cute. highly recommend!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/70405299e61c47fd9d70344fb93dccfb.jpeg?w=2268&h=4032"
    ],
    "productTitle": "Overstimulated Dads Club T-shirt",
    "productHandle": "overstimulated-dads-club-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_59.jpg?v=1791471876",
    "productUrl": "/products/overstimulated-dads-club-t-shirt"
  },
  {
    "id": "6a671342162dddc3fdca6a8f",
    "author": "L**a",
    "rating": 5,
    "date": "2026-07-27",
    "content": "Good quality thick material. Baggy style. I'm a UK size 8 and bought size small.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/7a927b9bf4e14f3fb1379bf3aa36cace.jpg?w=3472&h=4624"
    ],
    "productTitle": "Raise Them Kind Of Feral T-shirt",
    "productHandle": "raise-them-kind-of-feral-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/lQDPKHw5m-zXSU3NA3jNA3iw7oElyk5XHeAJ1xqIL1luAA-888-888.jpg?v=1791471881",
    "productUrl": "/products/raise-them-kind-of-feral-t-shirt"
  },
  {
    "id": "6a6615680b445406e80c8de3",
    "author": "A**d",
    "rating": 5,
    "date": "2026-07-26",
    "content": "This is the absolute best shirt ever! True to size and comical. I get so many people commenting on this shirt when I wear it!!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/d45d995e6990456782696e53bb199310.jpeg?w=4032&h=3024"
    ],
    "productTitle": "Raise Them Kind Of Feral T-shirt",
    "productHandle": "raise-them-kind-of-feral-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/lQDPKHw5m-zXSU3NA3jNA3iw7oElyk5XHeAJ1xqIL1luAA-888-888.jpg?v=1791471881",
    "productUrl": "/products/raise-them-kind-of-feral-t-shirt"
  },
  {
    "id": "6a657144162dddc3fdca6838",
    "author": "S**e",
    "rating": 5,
    "date": "2026-07-26",
    "content": "Great quality shirt. It looks exactly as pictured. It was a big hit at my friend's bday party.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/b293ea014a25417f88fad3eef295e6d9.jpg?w=801&h=773"
    ],
    "productTitle": "Motherhood Rock Skeleton T-shirt",
    "productHandle": "motherhood-rock-skeleton-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_57.jpg?v=1791471889",
    "productUrl": "/products/motherhood-rock-skeleton-t-shirt"
  },
  {
    "id": "6a656db2162dddc3fdca6830",
    "author": "M**e",
    "rating": 5,
    "date": "2026-07-26",
    "content": "I love it! Great quality tee and it survived the wash well!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/24c6e145ca094cf98bb6928fe1fcc319.jpg?w=2992&h=2992"
    ],
    "productTitle": "Motherhood Rock Skeleton T-shirt",
    "productHandle": "motherhood-rock-skeleton-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_57.jpg?v=1791471889",
    "productUrl": "/products/motherhood-rock-skeleton-t-shirt"
  },
  {
    "id": "6a62dabb0b445406e80c893c",
    "author": "B**h",
    "rating": 5,
    "date": "2026-07-24",
    "content": "This is the best frog shirt I could ask for. The shirt is good and sturdy. The print came out well... And there's a howling frog. Like.... Do you NEED anything else?? It's amazing.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/1dd974b932664575aee5325ffb92c170.jpg?w=3072&h=4080"
    ],
    "productTitle": "Cool Moms Club T-shirt",
    "productHandle": "cool-moms-club-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_45.jpg?v=1791471895",
    "productUrl": "/products/cool-moms-club-t-shirt"
  },
  {
    "id": "6a62d9cf162dddc3fdca644c",
    "author": "A**e",
    "rating": 5,
    "date": "2026-07-24",
    "content": "One of the coolest shirts I own. Incredible design and such a wonderful way to pay homage to the ultimate icon of kindness <3",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/e156316108744273a09776162e948c12.jpeg?w=2160&h=3840",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/eca8b0cd803c4cc89f8a6dd54311ccf6.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Cool Moms Club T-shirt",
    "productHandle": "cool-moms-club-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_45.jpg?v=1791471895",
    "productUrl": "/products/cool-moms-club-t-shirt"
  },
  {
    "id": "6888e5208e349d16b9515a63",
    "author": "E**l",
    "rating": 5,
    "date": "2025-07-29",
    "content": "Love this shirt, and there's so many more I want to order! <3 It took 2-3 weeks to get it in Tennessee, USA.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/085e6943dae14d09a7afeb94b13fb019.jpeg?w=634&h=846"
    ],
    "productTitle": "Overstimulated Mama Duck T-shirt",
    "productHandle": "overstimulated-mama-duck-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/14-94-0.jpg?v=1791471902",
    "productUrl": "/products/overstimulated-mama-duck-t-shirt"
  },
  {
    "id": "6885f09bb07307562a84aae1",
    "author": "A**e",
    "rating": 5,
    "date": "2025-07-27",
    "content": "I like this top a lot, it's a high quality cotton fabric but doesn't make you to hot, I sized up and it fits like a big nightdress, new fav, would defo buy from here again ✨️",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/3fe952c6359446faa0be1e1427720594.jpeg?w=1050&h=1867"
    ],
    "productTitle": "Overstimulated Mama Duck T-shirt",
    "productHandle": "overstimulated-mama-duck-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/14-94-0.jpg?v=1791471902",
    "productUrl": "/products/overstimulated-mama-duck-t-shirt"
  },
  {
    "id": "6a62b26b0b445406e80c8903",
    "author": "J**y",
    "rating": 5,
    "date": "2026-07-24",
    "content": "loved",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/22c19b5337974c88ac66da5a392be5ea.jpeg?w=4032&h=3024"
    ],
    "productTitle": "Tired moms club shirt",
    "productHandle": "tired-moms-club-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/ab22b0cbe1c206033191a4eb5a63e8e-0.jpg?v=1791471908",
    "productUrl": "/products/tired-moms-club-shirt"
  },
  {
    "id": "6a60624a162dddc3fdca60ce",
    "author": "S**e",
    "rating": 5,
    "date": "2026-07-22",
    "content": "So many comments on this Tshirt, I love it",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/a09a45eba0ef4706a9764d63876328d8.jpeg?w=1206&h=1229"
    ],
    "productTitle": "Tired moms club shirt",
    "productHandle": "tired-moms-club-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/ab22b0cbe1c206033191a4eb5a63e8e-0.jpg?v=1791471908",
    "productUrl": "/products/tired-moms-club-shirt"
  },
  {
    "id": "6a604422162dddc3fdca60a7",
    "author": "P**a",
    "rating": 5,
    "date": "2026-07-22",
    "content": "What a cool shirt. Who thinks of this stuff? I wore the shirt to a goth marketplace thing and got a few looks. Love the shirt and how it feels.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/3251c6c97881461eb6475f43efee3c5f.jpg?w=2296&h=4080"
    ],
    "productTitle": "Funny Fatherhood T-shirt",
    "productHandle": "funny-fatherhood-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/33-1-_5.jpg?v=1791529511",
    "productUrl": "/products/funny-fatherhood-t-shirt"
  },
  {
    "id": "6a5f2ba70b445406e80c83ec",
    "author": "W**t",
    "rating": 5,
    "date": "2026-07-21",
    "content": "Beautiful T-shirt love it really cool",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/947be119124349088b215b103c28714c.jpeg?w=3814&h=2502"
    ],
    "productTitle": "Funny Fatherhood T-shirt",
    "productHandle": "funny-fatherhood-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/33-1-_5.jpg?v=1791529511",
    "productUrl": "/products/funny-fatherhood-t-shirt"
  },
  {
    "id": "6a5e3fc40b445406e80c82a0",
    "author": "S**r",
    "rating": 5,
    "date": "2026-07-20",
    "content": "My favorite t-shirt. I love dragons and I love cats and a have a few problems (lol 🤣). Perfect combination for a design. The shirt is exactly as described. Plus, I was pleasantly surprised that it is a very soft cotton. Excellent quality.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/e783389fd6d0438291d4cda160e1869a.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Just a Dad Who Always Came Back With The Milk T-shirt",
    "productHandle": "just-a-dad-who-always-came-back-with-the-milk-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_29.jpg?v=1791529531",
    "productUrl": "/products/just-a-dad-who-always-came-back-with-the-milk-t-shirt"
  },
  {
    "id": "6a5d0f34162dddc3fdca5be5",
    "author": "P**s",
    "rating": 5,
    "date": "2026-07-19",
    "content": "Such a cute shirt! Perfect fit and i love it",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/9bdbefaf3baf450e94c4cbc58aa8b4fd.jpeg?w=2437&h=2287"
    ],
    "productTitle": "Just a Dad Who Always Came Back With The Milk T-shirt",
    "productHandle": "just-a-dad-who-always-came-back-with-the-milk-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_29.jpg?v=1791529531",
    "productUrl": "/products/just-a-dad-who-always-came-back-with-the-milk-t-shirt"
  },
  {
    "id": "6a5af5ad162dddc3fdca5936",
    "author": "A**s",
    "rating": 5,
    "date": "2026-07-18",
    "content": "Looove it!!!! The T-shirt is great quality!!!!!!!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/0e568b3a25a2496b8e9e285112e68a0e.jpeg?w=511&h=534"
    ],
    "productTitle": "Fatherhood Front And Back T-shirt",
    "productHandle": "fatherhood-front-and-back-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/32-1.jpg?v=1791529571",
    "productUrl": "/products/fatherhood-front-and-back-t-shirt"
  },
  {
    "id": "6a5aae2a162dddc3fdca58de",
    "author": "K**s",
    "rating": 5,
    "date": "2026-07-17",
    "content": "Love it",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/1dec3223ab654a5ab536ea87d0b80a1a.png?w=1206&h=2622"
    ],
    "productTitle": "Fatherhood Front And Back T-shirt",
    "productHandle": "fatherhood-front-and-back-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/32-1.jpg?v=1791529571",
    "productUrl": "/products/fatherhood-front-and-back-t-shirt"
  },
  {
    "id": "6a58f3ebd0e7746df1218281",
    "author": "J**r",
    "rating": 5,
    "date": "2026-07-16",
    "content": "This shirt was everything I hoped for—excellent quality, and a big hit with the holiday crowd!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/9a41943ab3934437a24fe5583d1fab2c.jpeg?w=1080&h=1920"
    ],
    "productTitle": "Cool Dads Club T-shirt",
    "productHandle": "cool-dads-club-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/33-_4.jpg?v=1791529595",
    "productUrl": "/products/cool-dads-club-t-shirt"
  },
  {
    "id": "6a58920a76c3ec4faf831d68",
    "author": "M**l",
    "rating": 5,
    "date": "2026-07-16",
    "content": "The t-shirt is great. The cotton feels great and it has a well made organic feel to it. I placed my ordernin white but changed it which was quick and easy, great communication. Unfortunately I’ve ordered it a size too big, so not sure I will actually get to wear it out much.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/bd7c2401601246e99931924edfad73ed.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Cool Dads Club T-shirt",
    "productHandle": "cool-dads-club-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/33-_4.jpg?v=1791529595",
    "productUrl": "/products/cool-dads-club-t-shirt"
  },
  {
    "id": "6a57a1110b445406e80c79cc",
    "author": "M**B",
    "rating": 5,
    "date": "2026-07-15",
    "content": "True to size. Great quality. Love my shirt.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/8509239738bd4b1c8fe657eb5d3806b6.jpeg?w=1476&h=2317"
    ],
    "productTitle": "I Keep All My Dad Jokes In A Dad-a-base T-shirt",
    "productHandle": "i-keep-all-my-dad-jokes-in-a-dad-a-base-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_28.jpg?v=1791529615",
    "productUrl": "/products/i-keep-all-my-dad-jokes-in-a-dad-a-base-t-shirt"
  },
  {
    "id": "6a5655ae76c3ec4faf831a6a",
    "author": "A** ",
    "rating": 5,
    "date": "2026-07-14",
    "content": "This shirt is perfect! Exceeded expectations and can’t wait to order another 🙌🏻",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/52f6b47f59bc42cf92abd5bb6e21b77b.jpeg?w=3024&h=4032"
    ],
    "productTitle": "I Keep All My Dad Jokes In A Dad-a-base T-shirt",
    "productHandle": "i-keep-all-my-dad-jokes-in-a-dad-a-base-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_28.jpg?v=1791529615",
    "productUrl": "/products/i-keep-all-my-dad-jokes-in-a-dad-a-base-t-shirt"
  },
  {
    "id": "6a561d4e0b445406e80c77b0",
    "author": "S**n",
    "rating": 5,
    "date": "2026-07-14",
    "content": "Didn’t think I could elevate my cool auntie status higher than it already was … but I was wrong 🔥💅🏻",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/f00a45aa1c3c473d91fae54bdbae8e5f.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Cool Dad T-shirt",
    "productHandle": "cool-dad-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_56.jpg?v=1791529635",
    "productUrl": "/products/cool-dad-t-shirt"
  },
  {
    "id": "6a553ae60b445406e80c767a",
    "author": "J**i",
    "rating": 5,
    "date": "2026-07-13",
    "content": "Super comfy heavyweight cotton shirt and the print is really high quality! Shrunk a little bit in the wash but at 5'10\" 150lbs the medium fits me nice and snug",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/582274a4ac654968a9a6318f52e1f8dd.jpg?w=1080&h=1438"
    ],
    "productTitle": "Cool Dad T-shirt",
    "productHandle": "cool-dad-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_56.jpg?v=1791529635",
    "productUrl": "/products/cool-dad-t-shirt"
  },
  {
    "id": "6a5402ad76c3ec4faf8316d5",
    "author": "T**a",
    "rating": 5,
    "date": "2026-07-12",
    "content": "I’m obsessed with my shirt! I love weenie dogs! My dream to own one! The print is top tier! Nothing cheap about it! The quality of the shirt is amazing. I will be purchasing again if I see other weenie dog prints.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/9054e20da1cf48ddbc184c253afd5ae6.jpeg?w=2316&h=3088"
    ],
    "productTitle": "I Tell Dad Jokes Periodically But Only When I'm In My Element T-shirt",
    "productHandle": "i-tell-dad-jokes-periodically-but-only-when-i-x27-m-in-my-element-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_33.jpg?v=1791529657",
    "productUrl": "/products/i-tell-dad-jokes-periodically-but-only-when-i-x27-m-in-my-element-t-shirt"
  },
  {
    "id": "6a5393330b445406e80c73dc",
    "author": "A**m",
    "rating": 5,
    "date": "2026-07-12",
    "content": "Second t shirt we’ve bought. Great quality and unique design. Perfect gift for a garden lover.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/ad7d2f1504d34f78a2d582282c0baa5f.jpeg?w=3020&h=3286"
    ],
    "productTitle": "I Tell Dad Jokes Periodically But Only When I'm In My Element T-shirt",
    "productHandle": "i-tell-dad-jokes-periodically-but-only-when-i-x27-m-in-my-element-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_33.jpg?v=1791529657",
    "productUrl": "/products/i-tell-dad-jokes-periodically-but-only-when-i-x27-m-in-my-element-t-shirt"
  },
  {
    "id": "6a5301b00b445406e80c732f",
    "author": "C**l",
    "rating": 5,
    "date": "2026-07-12",
    "content": "Fantastic shirts! Super comfy and great quality!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/bd46ef02dba447f19f32892c234547f1.jpg?w=2736&h=3648"
    ],
    "productTitle": "Daddy Goose T-shirt",
    "productHandle": "daddy-goose-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/09-65.jpg?v=1791529678",
    "productUrl": "/products/daddy-goose-t-shirt"
  },
  {
    "id": "6a518a311e439e7bc43781aa",
    "author": "K**s",
    "rating": 5,
    "date": "2026-07-11",
    "content": "Love the quality of the shirt, it’s an unisex shirt so I would size down.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/4cf405db5d924f0eaddb131f1cf7b575.jpg?w=3024&h=4032"
    ],
    "productTitle": "Daddy Goose T-shirt",
    "productHandle": "daddy-goose-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/09-65.jpg?v=1791529678",
    "productUrl": "/products/daddy-goose-t-shirt"
  },
  {
    "id": "6a510c3d1e439e7bc4378123",
    "author": "K**e",
    "rating": 5,
    "date": "2026-07-10",
    "content": "Hi quality, size is accurate, I love it !",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/09fabe0bbfb34e439b9908efb525dbe3.jpg?w=2316&h=3088",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/e2bab1871fc046b9b076833b65cab50f.jpg?w=2316&h=3088"
    ],
    "productTitle": "Top Dad T-shirt",
    "productHandle": "top-dad-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_32.jpg?v=1791529697",
    "productUrl": "/products/top-dad-t-shirt"
  },
  {
    "id": "6a50e8961e439e7bc43780d4",
    "author": "A**i",
    "rating": 5,
    "date": "2026-07-10",
    "content": "Love it!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/298653a3b37c41ac9bfc35e4de4abb30.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Top Dad T-shirt",
    "productHandle": "top-dad-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_32.jpg?v=1791529697",
    "productUrl": "/products/top-dad-t-shirt"
  },
  {
    "id": "6a506e3f1e439e7bc4378037",
    "author": "P**a",
    "rating": 5,
    "date": "2026-07-10",
    "content": "My favorite shirt! Fits true to size, not tight fitting and super soft! I bought 3 shirts and love then all. I've shared the link to this store a bunch!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/d713fed2f5924821a3cd437716237774.jpg?w=1440&h=2560"
    ],
    "productTitle": "Stumpfest & Lemonade T-shirt",
    "productHandle": "stumpfest-amp-lemonade-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_21.jpg?v=1791529718",
    "productUrl": "/products/stumpfest-amp-lemonade-t-shirt"
  },
  {
    "id": "6a4e6da60b445406e80c6cb4",
    "author": "T**t",
    "rating": 5,
    "date": "2026-07-08",
    "content": "Great fit. Good quality. Just a little pricey",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/3dbc25b54c184953900c4967d8ed7e37.jpg?w=1263&h=1714",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/f49e825d0c1446a7b4e2481274bf954f.jpg?w=3000&h=4000"
    ],
    "productTitle": "Stumpfest & Lemonade T-shirt",
    "productHandle": "stumpfest-amp-lemonade-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/31-_21.jpg?v=1791529718",
    "productUrl": "/products/stumpfest-amp-lemonade-t-shirt"
  },
  {
    "id": "6a4d1e5d1e439e7bc4377b36",
    "author": "U**a",
    "rating": 5,
    "date": "2026-07-07",
    "content": "very comfortable i love it",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/162af55b69454a0ba5c03ddab1e06254.jpg?w=3024&h=4032"
    ],
    "productTitle": "Retro 90s Cat Christmas T-shirt",
    "productHandle": "retro-90s-cat-christmas-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/21-17.jpg?v=1791531070",
    "productUrl": "/products/retro-90s-cat-christmas-t-shirt"
  },
  {
    "id": "6a4ac0c30b445406e80c66a7",
    "author": "H**n",
    "rating": 5,
    "date": "2026-07-05",
    "content": "I go so many compliments on this shirt. It’s a very comfortable and generous cut. I usually wear a L, but got an XL because I wanted it to fit very loose and long.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/1903a715632b4d55a9192e71a946bc77.jpeg?w=3024&h=4032",
      "https://plugin-img.myshopline.com/image/comment/1645426470535/dddffbbdacd74c1eb3497ed2b4ca6dad.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Retro 90s Cat Christmas T-shirt",
    "productHandle": "retro-90s-cat-christmas-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/21-17.jpg?v=1791531070",
    "productUrl": "/products/retro-90s-cat-christmas-t-shirt"
  },
  {
    "id": "69d75aabf5bee1a8864a88fc",
    "author": "M**s",
    "rating": 5,
    "date": "2026-04-09",
    "content": "Very happy with my first tee purchase from Rusty Fox Co. ... love the kitty design and excellen fabric quality 💯😻",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/2e5865bfa0cb49d595fd934044f22081.jpg?w=2968&h=3240"
    ],
    "productTitle": "Holiday Cat Christmas T-shirt",
    "productHandle": "holiday-cat-christmas-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/21-18.jpg?v=1791531075",
    "productUrl": "/products/holiday-cat-christmas-t-shirt"
  },
  {
    "id": "6a4a82790b445406e80c6638",
    "author": "A**u",
    "rating": 5,
    "date": "2026-07-05",
    "content": "Great quality and true fit. Took 2 weeks to arrive.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/10fc73824aa447d38f77896427b7e5b9.jpg?w=3000&h=2461"
    ],
    "productTitle": "Holiday Cat Christmas T-shirt",
    "productHandle": "holiday-cat-christmas-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/21-18.jpg?v=1791531075",
    "productUrl": "/products/holiday-cat-christmas-t-shirt"
  },
  {
    "id": "6a4956ea0b445406e80c64f3",
    "author": "S**s",
    "rating": 5,
    "date": "2026-07-04",
    "content": "Absolutely fantastic, got lots of laughs as a bday gift",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/991594cdce3d4a8796df2d03d4e8d321.jpg?w=3024&h=4032"
    ],
    "productTitle": "Raunchy Christmas Cat T-shirt",
    "productHandle": "raunchy-christmas-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/21-14.jpg?v=1791531081",
    "productUrl": "/products/raunchy-christmas-cat-t-shirt"
  },
  {
    "id": "6a48d4e61e439e7bc43774e0",
    "author": "B**g",
    "rating": 5,
    "date": "2026-07-04",
    "content": "Love my shirt. Everything went quickly, communication and tracking clear and smooth.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/55253800f0274f32932ee26c725e543e.jpg?w=2556&h=3408"
    ],
    "productTitle": "Raunchy Christmas Cat T-shirt",
    "productHandle": "raunchy-christmas-cat-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/21-14.jpg?v=1791531081",
    "productUrl": "/products/raunchy-christmas-cat-t-shirt"
  },
  {
    "id": "6a47ec411e439e7bc43773b4",
    "author": "P**e",
    "rating": 5,
    "date": "2026-07-03",
    "content": "Absolutely excellent customer service helping out when I ordered the wrong size \nLove the t shirt too. Great value.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/376e05298a8f47e3b8eb90951c6ae66e.jpeg?w=3024&h=4032"
    ],
    "productTitle": "Retro Shitters Full Griswold Christmas Tree Sweatshirt",
    "productHandle": "retro-shitters-full-griswold-christmas-tree-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/5-8.jpg?v=1791531086",
    "productUrl": "/products/retro-shitters-full-griswold-christmas-tree-sweatshirt"
  },
  {
    "id": "6a47ca5d0b445406e80c62d1",
    "author": "A**d",
    "rating": 5,
    "date": "2026-07-03",
    "content": "This is the greatest shirt! Super soft and comfortable.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/20fbac98838c4fc3b1bc86a896718ce9.jpeg?w=1793&h=2391"
    ],
    "productTitle": "Retro Shitters Full Griswold Christmas Tree Sweatshirt",
    "productHandle": "retro-shitters-full-griswold-christmas-tree-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/5-8.jpg?v=1791531086",
    "productUrl": "/products/retro-shitters-full-griswold-christmas-tree-sweatshirt"
  },
  {
    "id": "6a45c7ede78ed1683fbe15ab",
    "author": "T** ",
    "rating": 5,
    "date": "2026-07-02",
    "content": "Sam loved his shirt for Father’s Day!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/7a02eb1f785c480a91be37fbc13ca244.jpeg?w=3405&h=5186"
    ],
    "productTitle": "Vintage Christmas Cat Sweatshirt",
    "productHandle": "vintage-christmas-cat-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/06-17-3.jpg?v=1791531093",
    "productUrl": "/products/vintage-christmas-cat-sweatshirt"
  },
  {
    "id": "6a458605e78ed1683fbe1567",
    "author": "J**d",
    "rating": 5,
    "date": "2026-07-01",
    "content": "Bought this for my brother’s birthday present. He loves it. Fits as expected and good quality!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/1f3407824cc341bf831501ce9606676e.jpeg?w=1320&h=1146"
    ],
    "productTitle": "Vintage Christmas Cat Sweatshirt",
    "productHandle": "vintage-christmas-cat-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/06-17-3.jpg?v=1791531093",
    "productUrl": "/products/vintage-christmas-cat-sweatshirt"
  },
  {
    "id": "6a421b47e78ed1683fbe1060",
    "author": "K**a",
    "rating": 5,
    "date": "2026-06-29",
    "content": "Sehr schönes Shirt, gute Qualität! Gerne wieder!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/c62b4a86b8d54ffaa1cd5bd8b74bb4cd.jpg?w=2155&h=2937"
    ],
    "productTitle": "Cat Christmas T-shirt",
    "productHandle": "cat-christmas-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/21-7.jpg?v=1791531100",
    "productUrl": "/products/cat-christmas-t-shirt"
  },
  {
    "id": "6a3f62b5e78ed1683fbe0ce6",
    "author": "J**y",
    "rating": 5,
    "date": "2026-06-27",
    "content": "I LOVE this shirt. Such great heavy material and nice fit. And OMG so cute!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/efdfe1e70c094f0fb2d4d222edbda53f.jpg?w=3024&h=4032"
    ],
    "productTitle": "Cat Christmas T-shirt",
    "productHandle": "cat-christmas-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/21-7.jpg?v=1791531100",
    "productUrl": "/products/cat-christmas-t-shirt"
  },
  {
    "id": "6a3e2bfef15c0a3bf9c195b0",
    "author": "C**l",
    "rating": 4,
    "date": "2026-06-26",
    "content": "Very happy with the quality of the shirt. Shipping was quite a bit longer than it should have been but product was as described.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/2a40a6e116bf40d6825307545f1426be.jpg?w=3000&h=4000"
    ],
    "productTitle": "Western Roping Santa Pullover Sweatshirt",
    "productHandle": "western-roping-santa-pullover-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/8-107.jpg?v=1791531108",
    "productUrl": "/products/western-roping-santa-pullover-sweatshirt"
  },
  {
    "id": "6a3d4091f15c0a3bf9c194ab",
    "author": "J** ",
    "rating": 5,
    "date": "2026-06-25",
    "content": "Great fit, perfect design! Took it's maiden voyage on a hike through Sandy Ridge Reservation here in NE Ohio. 💛",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/f984dad400424896b47946e213e81ea2.jpg?w=2736&h=3648"
    ],
    "productTitle": "Western Roping Santa Pullover Sweatshirt",
    "productHandle": "western-roping-santa-pullover-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/8-107.jpg?v=1791531108",
    "productUrl": "/products/western-roping-santa-pullover-sweatshirt"
  },
  {
    "id": "6a3ad9d0f15c0a3bf9c19133",
    "author": "R**z",
    "rating": 5,
    "date": "2026-06-23",
    "content": "Quality shirts. Sharp printing. Fun",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/97930d61ca5e480e8000fc232851208d.jpg?w=2208&h=2538"
    ],
    "productTitle": "Monica Monica Have A Happy Hanukkah Sweatshirt",
    "productHandle": "monica-monica-have-a-happy-hanukkah-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/04-9.jpg?v=1791531116",
    "productUrl": "/products/monica-monica-have-a-happy-hanukkah-sweatshirt"
  },
  {
    "id": "6a3a1df9f6e3198021699034",
    "author": "A**e",
    "rating": 5,
    "date": "2026-06-23",
    "content": "It’s great, I love it",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/6fdfc899880948e9bc8a93f6016c8353.jpg?w=2316&h=3088"
    ],
    "productTitle": "Monica Monica Have A Happy Hanukkah Sweatshirt",
    "productHandle": "monica-monica-have-a-happy-hanukkah-sweatshirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/04-9.jpg?v=1791531116",
    "productUrl": "/products/monica-monica-have-a-happy-hanukkah-sweatshirt"
  },
  {
    "id": "6a360da8f6e3198021698a13",
    "author": "H**n",
    "rating": 5,
    "date": "2026-06-20",
    "content": "Love it! Great quality LOVE Comfort Colors T-shirts. Fits great. Proud towels wear it!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/1ce69abd782f4f27aebae1dc96b007e0.jpeg?w=1242&h=2208"
    ],
    "productTitle": "Christmas Tree T-Shirt",
    "productHandle": "christmas-tree-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/21-19-0.jpg?v=1791531122",
    "productUrl": "/products/christmas-tree-t-shirt"
  },
  {
    "id": "6a33260e02214529039e5dd5",
    "author": "B**i",
    "rating": 5,
    "date": "2026-06-17",
    "content": "Love the design and color. The material is soft.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/a6e10ad0382046198ee707e8f9d2568b.jpg?w=2052&h=3648"
    ],
    "productTitle": "Christmas Tree T-Shirt",
    "productHandle": "christmas-tree-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/21-19-0.jpg?v=1791531122",
    "productUrl": "/products/christmas-tree-t-shirt"
  },
  {
    "id": "6a314da3f6e31980216983a1",
    "author": "S**o",
    "rating": 5,
    "date": "2026-06-16",
    "content": "First of all, I love it. Have gotten several complements from strangers. As the delight I am, this was to be expected. But I’m glad I’m getting the reinforcement from the public now.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/00c67d0f2e5c4d73b5cb35a15f2819ed.jpeg?w=2316&h=3088"
    ],
    "productTitle": "Christmas Snowman T-Shirt",
    "productHandle": "christmas-snowman-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/22.jpg?v=1791531129",
    "productUrl": "/products/christmas-snowman-t-shirt"
  },
  {
    "id": "6a2edc9bd54b79f9b03b8473",
    "author": "S**y",
    "rating": 5,
    "date": "2026-06-14",
    "content": "I love this T-shirt. It’s my fave. I’ve had lots of great comments about it. Including’I want one too!’",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/e417a8d9550449d1be7b9808911ec4af.jpeg?w=2243&h=2619"
    ],
    "productTitle": "Christmas Snowman T-Shirt",
    "productHandle": "christmas-snowman-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/22.jpg?v=1791531129",
    "productUrl": "/products/christmas-snowman-t-shirt"
  },
  {
    "id": "6a2d86078c13de2a26657688",
    "author": "C**h",
    "rating": 5,
    "date": "2026-06-13",
    "content": "Really pleased with my t shirt, the cat is bigger than I was expecting, and not as bright, but I prefer it to the pictures. I really like that the print is not plastic, feels like a proper silk screen. Very happy that I ordered an extra one for my daughter, can’t wait to give it to her.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/af8ed0d9ab4a4c7a8ba803c2da1b7513.jpeg?w=2062&h=3664"
    ],
    "productTitle": "Cute Cat Christmas T-shirt",
    "productHandle": "cute-cat-christmas-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/9-64-800x.jpg?v=1791531136",
    "productUrl": "/products/cute-cat-christmas-t-shirt"
  },
  {
    "id": "6a2a34aad54b79f9b03b7a04",
    "author": "M**n",
    "rating": 5,
    "date": "2026-06-11",
    "content": "The shirt was well made (quality material), arrived on time and I get compliments all the time! I usually wear a large but was afraid it would run small so I got an XL, but it’s too big. I’m going to get another one, but in a large :)",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/3901ccc673aa453e8123fc1503a296f9.jpeg?w=3465&h=4320"
    ],
    "productTitle": "Cute Cat Christmas T-shirt",
    "productHandle": "cute-cat-christmas-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/9-64-800x.jpg?v=1791531136",
    "productUrl": "/products/cute-cat-christmas-t-shirt"
  },
  {
    "id": "6a2791498c13de2a266568b0",
    "author": "C**r",
    "rating": 5,
    "date": "2026-06-09",
    "content": "My crazy cat lady....\nGreat quality shirts!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/938bb013b32747ab8580f94056f91fa4.jpg?w=3000&h=4000"
    ],
    "productTitle": "Santa T-shirt",
    "productHandle": "santa-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/11.jpg?v=1791531141",
    "productUrl": "/products/santa-t-shirt"
  },
  {
    "id": "6a27892e8c13de2a266568a1",
    "author": "R**k",
    "rating": 5,
    "date": "2026-06-09",
    "content": "I love these shirts and I guess I must have about ten now. I'm usually an XXL but the XL fits perfectly. The best quality t-shirts I own.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/70fe43eac5dd4a37a68c9ca770fa1983.jpg?w=1776&h=3310"
    ],
    "productTitle": "Santa T-shirt",
    "productHandle": "santa-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/11.jpg?v=1791531141",
    "productUrl": "/products/santa-t-shirt"
  },
  {
    "id": "675daf4562146850c3beb7b7",
    "author": "C**y",
    "rating": 5,
    "date": "2024-12-14",
    "content": "The shirts fit true to size listed. They are comfortable and my parents thought they were hilarious when we wore them for Thanksgiving. I've received multiple compliments.",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/6c2b641571644aa3aba1547ada7de253.png?w=1179&h=2556"
    ],
    "productTitle": "Couples Christmas T-Shirt",
    "productHandle": "couples-christmas-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/10-17-1-0.jpg?v=1791531151",
    "productUrl": "/products/couples-christmas-t-shirt"
  },
  {
    "id": "6a261d508f99a6a6cd8cdafc",
    "author": "R**s",
    "rating": 5,
    "date": "2026-06-08",
    "content": "Great quality! Teenager loves it! Probably need to buy another one!",
    "images": [
      "https://plugin-img.myshopline.com/image/comment/1645426470535/feb3818c5b6d4f32a2fb0517e3c9cfc8.jpg?w=1848&h=4000"
    ],
    "productTitle": "Couples Christmas T-Shirt",
    "productHandle": "couples-christmas-t-shirt",
    "productImage": "https://cdn.shopify.com/s/files/1/1003/3286/3858/files/10-17-1-0.jpg?v=1791531151",
    "productUrl": "/products/couples-christmas-t-shirt"
  }
];
